<template>
  <div>
    <PageAllow controller="Settings" action="businessSetting" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-sheet class="page-card transparent-background-color">
        <ValidationObserver ref="observer">
          <v-expansion-panels v-model="panels" multiple focusable>
            <!-- 品牌权益 -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("BusinessSetting.AccountInfo.ObjectName") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t("BusinessSetting.AccountInfo.account_id") +
                          $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7" v-if="accountInfo">
                        {{ accountInfo.account_id }}
                        <span class="subtitle-2">
                          {{ $t("BusinessSetting.AccountInfo.accountIdHint") }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t("BusinessSetting.AccountInfo.available_shops", [
                            $consts.shopName(),
                          ]) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7" v-if="settings">
                        <span v-if="settings.max_active_shops == -1">
                          {{ $t("BusinessSetting.AccountInfo.unlimited") }}
                        </span>
                        <span v-else>
                          {{ settings.max_active_shops }}
                          <span class="subtitle-2">
                            {{
                              $t("BusinessSetting.AccountInfo.remain_count", [
                                settings.remain_shop_count,
                              ])
                            }}
                          </span>
                        </span>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      v-if="settingValues.shop_psi_max_num != null"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t("BusinessSetting.AccountInfo.available_shops", [
                            $t(
                              "BusinessSetting.AccountInfo.shop_psi_surplus_num"
                            ),
                          ]) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7" v-if="settings">
                        <span>
                          {{ settingValues.shop_psi_max_num }}
                          <span class="subtitle-2">
                            {{
                              $t("BusinessSetting.AccountInfo.remain_count", [
                                settingValues.shop_psi_surplus_num > 0
                                  ? settingValues.shop_psi_surplus_num
                                  : 0,
                              ])
                            }}
                          </span>
                        </span>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t("BusinessSetting.AccountInfo.time_expired") +
                          $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7" v-if="accountInfo">
                        {{ accountInfo.time_expired | formatDate }}
                        <span
                          :class="
                            accountInfo.remain_expired_days <= 10
                              ? 'text-caption accent--text'
                              : 'subtitle-2'
                          "
                        >
                          {{
                            accountInfo.remain_expired_days == 0
                              ? $t(
                                  "BusinessSetting.AccountInfo.account_expired"
                                )
                              : $t("BusinessSetting.AccountInfo.remain_count", [
                                  accountInfo.remain_expired_days,
                                  $t("BusinessSetting.day"),
                                ])
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t("BusinessSetting.AccountInfo.sms_remain") +
                          $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="5" v-if="settings">
                        {{ settings.sms_max }}
                        {{ $t("BusinessSetting.AccountInfo.sms_strip") }}
                        <span
                          :class="
                            settings.sms_remain <= 50
                              ? 'text-caption accent--text'
                              : 'subtitle-2'
                          "
                        >
                          {{
                            $t("BusinessSetting.AccountInfo.remain_count", [
                              settings.sms_remain,
                              $t("BusinessSetting.AccountInfo.sms_strip"),
                            ])
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t("BusinessSetting.AccountInfo.sms_remain_notice") +
                          $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.sms_remain_notice"
                          :disabled="businessPermission.find((d) => d == 1) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- 密码管理 -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("BusinessSetting.PassWordManagement.ObjectName") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.PassWordManagement.complex_password"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.complex_password"
                          :disabled="businessPermission.find((d) => d == 2) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.PassWordManagement.expired_password"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.expired_password"
                          :disabled="businessPermission.find((d) => d == 2) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider v-if="settingValues.expired_password" />
                    <v-row align="center" v-if="settingValues.expired_password">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.PassWordManagement.password_expiry_date"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-text-field
                          v-model="settingValues.password_expiry_date"
                          :disabled="businessPermission.find((d) => d == 2) ? false : true"
                          single-line
                          :suffix="$t('BusinessSetting.day')"
                          type="number"
                          style="max-width: 180px"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- APP/小程序设置 -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("BusinessSetting.AppAndWxApp.ObjectName") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row align="center" class="my-1">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t("BusinessSetting.AppAndWxApp.image_loding") +
                          $t("Global.colon")
                        }}
                        <br />
                        <v-btn
                          color="primary"
                          class="my-1"
                          x-small
                          outlined
                          @click.stop="clearImage('app_loading_page')"
                          :disabled="businessPermission.find((d) => d == 3) ? false : true"
                        >
                          {{ $t("BusinessSetting.AppAndWxApp.clear_image") }}
                        </v-btn>
                      </v-col>
                      <v-col cols="7">
                        <v-row>
                          <v-col cols="6">
                            <v-card v-if="APP_loading_image" max-width="140px">
                              <v-img
                                :src="APP_loading_image"
                                @click.stop="
                                  $showFullscreenImages([APP_loading_image])
                                "
                              >
                                <v-tooltip right v-if="APP_loading_image">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="secondary"
                                      class="pa-2 float-right"
                                      :disabled="businessPermission.find((d) => d == 3) ? false : true"
                                      @click.stop="
                                        !APP_loading_image.startsWith(
                                          'data:image/'
                                        ) &&
                                        APP_loading_image ==
                                          settingValues.app_loading_page
                                          ? (settingValues.app_loading_page =
                                              APP_loading_image =
                                                null)
                                          : (APP_loading_image = null)
                                      "
                                    >
                                      fa-times
                                    </v-icon>
                                  </template>
                                  <span>
                                    {{
                                      $t(
                                        "BusinessSetting.AppAndWxApp.clear_image"
                                      )
                                    }}</span
                                  >
                                </v-tooltip>
                              </v-img>
                            </v-card>
                            <v-file-input
                              ref="APP_loading_image_file"
                              show-size
                              prepend-icon="fa-camera"
                              accept="image/png, image/jpeg"
                              persistent-hint
                              :disabled="businessPermission.find((d) => d == 3) ? false : true"
                              :placeholder="
                                $t('BusinessSetting.AppAndWxApp.imgPlaceholder')
                              "
                              :hint="
                                $t('BusinessSetting.AppAndWxApp.imgHint', [
                                  '1080',
                                  '1920',
                                ])
                              "
                              :rules="imgRules"
                              v-model="APP_loading_image_file"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center" class="my-1">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t("BusinessSetting.AppAndWxApp.image_logo") +
                          $t("Global.colon")
                        }}
                        <br />
                        <v-btn
                          color="primary"
                          class="my-1"
                          x-small
                          outlined
                          @click="clearImage('app_title_logo')"
                          :disabled="businessPermission.find((d) => d == 3) ? false : true"
                        >
                          {{ $t("BusinessSetting.AppAndWxApp.clear_image") }}
                        </v-btn>
                      </v-col>

                      <v-col cols="7">
                        <v-row>
                          <v-col cols="6">
                            <v-card v-if="APP_log_image" max-width="140">
                              <v-img
                                :src="APP_log_image"
                                @click.stop="
                                  $showFullscreenImages([APP_log_image])
                                "
                              >
                                <v-tooltip right v-if="APP_log_image">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      color="secondary"
                                      class="pa-2 float-right"
                                      :disabled="businessPermission.find((d) => d == 3) ? false : true"
                                      @click.stop="
                                        !APP_log_image.startsWith(
                                          'data:image/'
                                        ) &&
                                        APP_log_image ==
                                          settingValues.app_title_logo
                                          ? (settingValues.app_title_logo =
                                              APP_log_image =
                                                null)
                                          : (APP_log_image = null)
                                      "
                                    >
                                      fa-times
                                    </v-icon>
                                  </template>
                                  <span>
                                    {{
                                      $t(
                                        "BusinessSetting.AppAndWxApp.clear_image"
                                      )
                                    }}</span
                                  >
                                </v-tooltip>
                              </v-img>
                            </v-card>
                            <v-file-input
                              ref="APP_log_image_file"
                              show-size
                              prepend-icon="fa-camera"
                              accept="image/png, image/jpeg"
                              persistent-hint
                              :disabled="businessPermission.find((d) => d == 3) ? false : true"
                              :placeholder="
                                $t('BusinessSetting.AppAndWxApp.imgPlaceholder')
                              "
                              :hint="
                                $t('BusinessSetting.AppAndWxApp.imgHint', [
                                  '1200',
                                  '600',
                                ])
                              "
                              :rules="imgRules"
                              v-model="APP_log_image_file"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AppAndWxApp.customer_server_tel"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              v-model="settingValues.customer_server_tel"
                              :disabled="businessPermission.find((d) => d == 3) ? false : true"
                              single-line
                              :hint="
                                $t(
                                  'BusinessSetting.AppAndWxApp.customer_server_tel_hint'
                                )
                              "
                              persistent-hint
                              dense
                              class="pb-2"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AppAndWxApp.shopRegister.auto_make"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="shop_register.auto_make"
                          :disabled="businessPermission.find((d) => d == 3) ? false : true"
                          dense
                          :hint="
                            $t(
                              'BusinessSetting.AppAndWxApp.shopRegister.auto_make_hint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <div v-if="Number(shop_register.auto_make)" class="mx-4">
                      <v-row align="center">
                        <v-col cols="3" class="font-weight-bold text-left">
                          {{
                            $t(
                              "BusinessSetting.AppAndWxApp.shopRegister.template_setting"
                            ) + $t("Global.colon")
                          }}
                        </v-col>
                        <v-col cols="9" md="7">
                          <v-radio-group
                            row
                            v-model="shop_register.template_setting"
                            :disabled="businessPermission.find((d) => d == 3) ? false : true"
                          >
                            <v-radio
                              :label="
                                $t(
                                  'BusinessSetting.AppAndWxApp.shopRegister.default_template'
                                )
                              "
                              :key="1"
                              value="1"
                            />
                            <v-radio
                              :label="
                                $t(
                                  'BusinessSetting.AppAndWxApp.shopRegister.district_bind_template'
                                )
                              "
                              :key="2"
                              value="2"
                            />
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col cols="3" class="font-weight-bold text-left">
                          {{
                            $t(
                              "BusinessSetting.AppAndWxApp.shopRegister.default_district"
                            ) + $t("Global.colon")
                          }}
                        </v-col>

                        <v-col cols="12" sm="6">
                          <ValidationProvider
                            v-slot="{ errors }"
                            :name="
                              $t(
                                'BusinessSetting.AppAndWxApp.shopRegister.default_district'
                              )
                            "
                            rules="required"
                          >
                            <v-row>
                              <span class="d-flex pl-3" style="width: 232px">
                                <SearcherDistrict
                                  v-model="shop_register.district_info"
                                  :isDisabled="businessPermission.find((d) => d == 3) ? false : true"
                                  no-label
                                  unclearable
                                  :errorMessages="
                                    !errors.length &&
                                    !shop_register.district_info
                                      ? [$t('Global.requried')]
                                      : errors
                                  "
                                />
                              </span>
                            </v-row>
                            <!-- :dense="!errors.length && !shop_register.district_info" -->
                            <!-- <v-row v-if="!shop_register.district_info && !errors.length">
                              <span class="danger--text caption pl-3 pb-1">
                                {{$t('Global.requried')}}
                              </span>
                          </v-row> -->
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row
                        align="center"
                        v-if="shop_register.template_setting == 1"
                      >
                        <v-col cols="3" class="font-weight-bold text-left">
                          {{
                            $t(
                              "BusinessSetting.AppAndWxApp.shopRegister.default_template"
                            ) + $t("Global.colon")
                          }}
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6">
                          <span class="d-flex" style="width: 220px">
                            <SearcherTemplate
                              v-model="shop_register.template_info"
                              :isDisabled="businessPermission.find((d) => d == 3) ? false : true"
                              unclearable
                              no-label
                            />
                          </span>
                        </v-col>
                      </v-row>
                      <v-row
                        align="center"
                        v-if="shop_register.template_setting == 2"
                      >
                        <v-col cols="3" class="font-weight-bold text-left">
                          {{
                            $t(
                              "BusinessSetting.AppAndWxApp.shopRegister.district_binding"
                            ) + $t("Global.colon")
                          }}
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6">
                          <v-btn
                            small
                            dark
                            color="info"
                            class="px-2 me-2 mb-1"
                            @click.stop="getDistrictTree()"
                            :disabled="businessPermission.find((d) => d == 3) ? false : true"
                          >
                            {{
                              $t(
                                "BusinessSetting.AppAndWxApp.shopRegister.district_configuration"
                              )
                            }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                    <v-divider v-if="shop_register.auto_make" class="mt-3" />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t("BusinessSetting.AppAndWxApp.base_news_display") +
                          $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.base_news_display"
                          :disabled="businessPermission.find((d) => d == 3) ? false : true"
                          :hint="
                            $t(
                              'BusinessSetting.AppAndWxApp.base_news_display_hint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- 后台端相关设置 -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("BusinessSetting.BackstageSettings.ObjectName") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.BackstageSettings.shop_custom_name"
                          )
                        }}
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t(
                            "BusinessSetting.BackstageSettings.shop_terminal_custom_name"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              v-model="settingValues.shop_custom_name"
                              :disabled="businessPermission.find((d) => d == 4) ? false : true"
                              single-line
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t(
                            "BusinessSetting.BackstageSettings.agent_custom_name"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              v-model="settingValues.agent_custom_name"
                              :disabled="businessPermission.find((d) => d == 4) ? false : true"
                              single-line
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <!-- 品牌端登录弹窗提醒：拿掉 -->
                    <!-- <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.BackstageSettings.remind_setting"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.remind_setting"
                          :hint="
                            $t(
                              'BusinessSetting.BackstageSettings.remind_setting_hint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider /> -->
                    <!-- 图片上传设置：拿掉 -->
                    <!-- <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.BackstageSettings.upload_setting"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.upload_setting"
                        >
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.BackstageSettings.obs_storage'
                              )
                            "
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.BackstageSettings.hard_disk_storage'
                              )
                            "
                            :key="2"
                            :value="2"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.BackstageSettings.both_coexisting'
                              )
                            "
                            :key="3"
                            :value="3"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider /> -->
                    <v-row align="center">
                      <v-col cols="12" class="text-left mt-3">
                        <span class="font-weight-bold">
                          {{
                            $t(
                              "BusinessSetting.BackstageSettings.order_ext_code_name_custom"
                            )
                          }}
                        </span>
                        {{
                          $t(
                            "BusinessSetting.BackstageSettings.order_ext_code_name_custom_hint"
                          )
                        }}
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t(
                            "BusinessSetting.BackstageSettings.order_ext_code_display"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row>
                          <v-col cols="6">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :name="
                                $t(
                                  'BusinessSetting.BackstageSettings.order_ext_code_display'
                                )
                              "
                              rules="max:8"
                            >
                              <v-text-field
                                v-model="ext_code_display.order"
                                :disabled="businessPermission.find((d) => d == 4) ? false : true"
                                single-line
                                dense
                                :error-messages="errors"
                              >
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t(
                            "BusinessSetting.BackstageSettings.return_order_ext_code_display"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row>
                          <v-col cols="6">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :name="
                                $t(
                                  'BusinessSetting.BackstageSettings.return_order_ext_code_display'
                                )
                              "
                              rules="max:8"
                            >
                              <v-text-field
                                v-model="ext_code_display.return_order"
                                :disabled="businessPermission.find((d) => d == 4) ? false : true"
                                single-line
                                dense
                                :error-messages="errors"
                              >
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t(
                            "BusinessSetting.BackstageSettings.purchase_ext_code_display"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row>
                          <v-col cols="6">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :name="
                                $t(
                                  'BusinessSetting.BackstageSettings.purchase_ext_code_display'
                                )
                              "
                              rules="max:8"
                            >
                              <v-text-field
                                v-model="ext_code_display.purchase"
                                :disabled="businessPermission.find((d) => d == 4) ? false : true"
                                single-line
                                dense
                                :error-messages="errors"
                              >
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t(
                            "BusinessSetting.BackstageSettings.stockOut_order_ext_code_display"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row>
                          <v-col cols="6">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :name="
                                $t(
                                  'BusinessSetting.BackstageSettings.stockOut_order_ext_code_display'
                                )
                              "
                              rules="max:8"
                            >
                              <v-text-field
                                v-model="ext_code_display.stock_out_order"
                                :disabled="businessPermission.find((d) => d == 4) ? false : true"
                                single-line
                                dense
                                :error-messages="errors"
                              >
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t(
                            "BusinessSetting.BackstageSettings.stockIn_order_ext_code_display"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row>
                          <v-col cols="6">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :name="
                                $t(
                                  'BusinessSetting.BackstageSettings.stockIn_order_ext_code_display'
                                )
                              "
                              rules="max:8"
                            >
                              <v-text-field
                                v-model="ext_code_display.stock_in_order"
                                :disabled="businessPermission.find((d) => d == 4) ? false : true"
                                single-line
                                dense
                                :error-messages="errors"
                              >
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.StockManagementSetting.purchase_price_valuation"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.purchase_price_valuation"
                          :disabled="businessPermission.find((d) => d == 4) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider
                      v-if="
                        $permission.permissionAllow(
                          'CloudPrintTemplates',
                          'print'
                        )
                      "
                    />
                    <v-row
                      align="center"
                      v-if="
                        $permission.permissionAllow(
                          'CloudPrintTemplates',
                          'print'
                        )
                      "
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.StockManagementSetting.cloudPrintEnable"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.cloud_print_enable"
                          :disabled="businessPermission.find((d) => d == 4) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- 要货管理相关设置 -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("BusinessSetting.AccountOrderSettings.ObjectName") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.account_order_rule"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.order_method"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                        >
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.AccountOrderSettings.once_a_day'
                              )
                            "
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.AccountOrderSettings.order_count_unlimited'
                              )
                            "
                            :key="2"
                            :value="2"
                          />
                          <!-- 暂时隐藏 分渠道分时段模式-->
                          <!-- <v-radio
                            :label="
                              $t(
                                'BusinessSetting.AccountOrderSettings.set_source_and_time_bucket'
                              )
                            "
                            :key="3"
                            :value="3"
                          /> -->
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      class="mb-1"
                      v-if="settingValues.order_method == 1"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.order_time"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row>
                          <v-col cols="5" md="4">
                            <SearcherDatetime
                              class="my-n2"
                              v-model="order_start"
                              type="minutes"
                              single-line
                              dense
                              hide-details
                              hide-icon
                              disabledBeforeToday
                              readonly
                              :disabled="businessPermission.find((d) => d == 5) ? false : true"
                            >
                              <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                  {{ message }}
                                </div>
                              </template>
                            </SearcherDatetime>
                          </v-col>
                          <v-col cols="1" class="text-center">~</v-col>
                          <v-col cols="5" md="4">
                            <SearcherDatetime
                              class="my-n2"
                              v-model="order_end"
                              type="minutes"
                              single-line
                              dense
                              hide-details
                              hide-icon
                              disabledBeforeToday
                              readonly
                              :disabled="businessPermission.find((d) => d == 5) ? false : true"
                            >
                              <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                  {{ message }}
                                </div>
                              </template>
                            </SearcherDatetime>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      class="mb-1"
                      v-if="settingValues.order_method == 1"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.once_a_day_without_admin"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.order_method_without_admin"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <!-- 暂时隐藏 分渠道分时段模式-->
                    <!-- <v-row
                      align="center"
                      v-if="settingValues.order_method == 3"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.period_origin_model"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-btn class="primary mb-4" small>
                          {{
                            $t(
                              "BusinessSetting.AccountOrderSettings.period_origin_setting"
                            )
                          }}
                        </v-btn>
                      </v-col>
                    </v-row> -->
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.use_order_cycle"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.use_ordercycle"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                          max="2"
                          :hint="
                            $t(
                              'BusinessSetting.AccountOrderSettings.use_order_cycle_hint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      v-if="settingValues.use_ordercycle"
                      class="mx-3"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.baseCloseOrdercycle"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.base_close_ordercycle"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                          max="2"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      v-if="settingValues.use_ordercycle"
                      class="mx-3"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.ordercycleDefault"
                          ) + $t("Global.colon")
                        }}
                        <br />
                        <v-btn
                          color="primary"
                          x-small
                          outlined
                          class="my-2"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                          @click="
                            $router.push(
                              '/settings/bussiness-settings/order-cycles'
                            )
                          "
                        >
                          {{
                            $t(
                              "BusinessSetting.AccountOrderSettings.ordecycleSetting"
                            )
                          }}
                        </v-btn>
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-select
                          v-model="settingValues.ordercycle"
                          :items="orderCycles"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                          item-text="name"
                          item-value="code"
                          style="max-width: 240px"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <!-- 配送单打印/批量配送打印启用自动配送设置: 拿掉 -->
                    <!-- <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.distributionPrintAndDistributeSetting"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="
                            settingValues.distribution_print_and_distribute
                          "
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider /> -->
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.abnormalExamineSetting"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="abnormalExamine"
                          :disabled="
                            (settingValues.abnormal_examine ? true : false) && (businessPermission.find((d) => d == 5) ? false : true)
                          "
                          :hint="
                            $t(
                              'BusinessSetting.AccountOrderSettings.abnormal_examine_hint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <!-- 启用自动验货设置 -->
                    <v-row align="center" v-if="!abnormalExamine">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.autoExamineSetting"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.auto_examine"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true">
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider v-if="!abnormalExamine" />
                    <v-row align="center" v-if="settingValues.auto_examine">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.autoExamineDays"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <ValidationProvider
                          v-slot="{ errors }"
                          :rules="{
                            min_value: {
                              min: 1,
                            },
                            max_value: {
                              max: 30,
                            },
                          }"
                        >
                          <v-text-field
                            v-model="settingValues.auto_examine_days"
                            :disabled="businessPermission.find((d) => d == 5) ? false : true"
                            dense
                            style="max-width: 120px"
                            :suffix="$t('BusinessSetting.day')"
                            :error-messages="errors"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-divider v-if="settingValues.auto_examine" />
                    <!-- 发票设置模块：拿掉 -->
                    <!-- <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left my-4">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.invoice_setting.title"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row class="ml-0">
                          <v-checkbox
                            v-model="invoiceTypeNormal"
                            class=""
                            :label="
                              $t(
                                'BusinessSetting.AccountOrderSettings.invoice_setting.invoice_type_normal'
                              )
                            "
                          ></v-checkbox>
                          <v-checkbox
                            v-model="invoiceTypeValueAdded"
                            class="ms-2"
                            :label="
                              $t(
                                'BusinessSetting.AccountOrderSettings.invoice_setting.invoice_type_value_added'
                              )
                            "
                          ></v-checkbox>
                        </v-row>
                      </v-col>
                    </v-row>
                    <div
                      class="mx-4"
                      v-if="invoiceTypeNormal || invoiceTypeValueAdded"
                    >
                      <v-row class="ml-0 subtitle-2">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.invoiceTaxes"
                          )
                        }}
                      </v-row>
                      <v-row align="center" v-if="invoiceTypeNormal">
                        <v-col cols="3" class="font-weight-bold text-left">
                          {{
                            $t(
                              "BusinessSetting.AccountOrderSettings.invoiceTypeNormalPercent"
                            ) + $t("Global.colon")
                          }}
                        </v-col>
                        <v-col cols="9" md="7">
                          <v-text-field
                            v-model="settingValues.invoice_type_normal_percent"
                            dense
                            single-line
                            suffix="%"
                            type="number"
                            style="max-width: 150px"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row align="center" v-if="invoiceTypeValueAdded">
                        <v-col cols="3" class="font-weight-bold text-left">
                          {{
                            $t(
                              "BusinessSetting.AccountOrderSettings.invoiceTypeValueAddedPercent"
                            ) + $t("Global.colon")
                          }}
                        </v-col>
                        <v-col cols="9" md="7">
                          <v-text-field
                            v-model="
                              settingValues.invoice_type_value_added_percent
                            "
                            dense
                            single-line
                            suffix="%"
                            type="number"
                            style="max-width: 150px"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                    <v-divider /> -->
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.examineAutoReturn"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.examine_auto_return"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                          :hint="
                            $t(
                              'BusinessSetting.AccountOrderSettings.examine_auto_return_hint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.shopExamineMustImg"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.shop_examine_must_img"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row class="mt-2">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.appPriceWarningRange"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row align="center" class="my-1">
                          <ValidationProvider
                            v-slot="{ errors }"
                            :rules="{
                              min_value: {
                                min: 0,
                              },
                            }"
                          >
                            <v-text-field
                              v-model="settingValues.app_price_alert_min"
                              :disabled="businessPermission.find((d) => d == 5) ? false : true"
                              single-line
                              dense
                              suffix="%"
                              type="number"
                              style="max-width: 410px"
                              :error-messages="errors"
                            >
                              <template v-slot:prepend>
                                <span class="caption" style="min-width: 120px">
                                  {{
                                    $t(
                                      "BusinessSetting.AccountOrderSettings.appPriceAlertMinHeader"
                                    )
                                  }}
                                </span>
                              </template>
                              <template v-slot:append-outer>
                                <span class="caption" style="min-width: 120px">
                                  {{
                                    $t(
                                      "BusinessSetting.AccountOrderSettings.appPriceAlertMinEnd"
                                    )
                                  }}
                                </span>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-row>
                        <v-row align="center" class="mt-1 mb-2">
                          <ValidationProvider
                            v-slot="{ errors }"
                            :rules="{
                              min_value: {
                                min: 0,
                              },
                            }"
                          >
                            <v-text-field
                              v-model="settingValues.app_price_alert_max"
                              :disabled="businessPermission.find((d) => d == 5) ? false : true"
                              single-line
                              dense
                              suffix="%"
                              type="number"
                              style="max-width: 410px"
                              :error-messages="errors"
                            >
                              <template v-slot:prepend>
                                <span class="caption" style="min-width: 120px">
                                  {{
                                    $t(
                                      "BusinessSetting.AccountOrderSettings.appPriceAlertMaxHeader"
                                    )
                                  }}
                                </span>
                              </template>
                              <template v-slot:append-outer>
                                <span class="caption" style="min-width: 120px">
                                  {{
                                    $t(
                                      "BusinessSetting.AccountOrderSettings.appPriceAlertMaxEnd"
                                    )
                                  }}
                                </span>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.autoPriceType"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.auto_price_type"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                        >
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.AccountOrderSettings.auto_price_free'
                              )
                            "
                            :key="0"
                            :value="0"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.AccountOrderSettings.auto_template_price'
                              )
                            "
                            :key="1"
                            :value="1"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider v-if="!settingValues.stock_position_setting" />
<!--                    <v-row align="center">-->
<!--                      <v-col cols="3" class="font-weight-bold text-left">-->
<!--                        {{-->
<!--                          $t(-->
<!--                            "BusinessSetting.AccountOrderSettings.orderMemoDisplay"-->
<!--                          ) + $t("Global.colon")-->
<!--                        }}-->
<!--                      </v-col>-->
<!--                      <v-col cols="9" md="7">-->
<!--                        <v-radio-group-->
<!--                          row-->
<!--                          v-model="settingValues.order_memo_display"-->
<!--                          :disabled="businessPermission.find((d) => d == 5) ? false : true"-->
<!--                        >-->
<!--                          <v-radio-->
<!--                            :label="-->
<!--                              $t(-->
<!--                                'BusinessSetting.AccountOrderSettings.orderMemoDisplayType.order'-->
<!--                              )-->
<!--                            "-->
<!--                            :key="1"-->
<!--                            :value="1"-->
<!--                          />-->
<!--                          <v-radio-->
<!--                            :label="-->
<!--                              $t(-->
<!--                                'BusinessSetting.AccountOrderSettings.orderMemoDisplayType.shop'-->
<!--                              )-->
<!--                            "-->
<!--                            :key="2"-->
<!--                            :value="2"-->
<!--                          />-->
<!--                          <v-radio-->
<!--                            :label="-->
<!--                              $t(-->
<!--                                'BusinessSetting.AccountOrderSettings.orderMemoDisplayType.both'-->
<!--                              )-->
<!--                            "-->
<!--                            :key="3"-->
<!--                            :value="3"-->
<!--                          />-->
<!--                        </v-radio-group>-->
<!--                      </v-col>-->
<!--                    </v-row>-->
                    <!-- TODO: 缺批量出库的权限 -->
<!--                    <v-divider v-if="!settingValues.stock_position_setting" />-->
                    <v-row
                      align="center"
                      v-if="!settingValues.stock_position_setting"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.batchStockOutType.title"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.batch_stock_out_type"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                        >
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.AccountOrderSettings.batchStockOutType.on'
                              )
                            "
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.AccountOrderSettings.batchStockOutType.off'
                              )
                            "
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center" v-if="false">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.orderPriceNode.title"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.order_price_node"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                        >
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.AccountOrderSettings.orderPriceNode.one'
                              )
                            "
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.AccountOrderSettings.orderPriceNode.two'
                              )
                            "
                            :key="2"
                            :value="2"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      v-if="
                        $permission.permissionAllow(
                          'StockOuts',
                          'commonSortingOut'
                        )
                      "
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.lower_percent"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <ValidationProvider
                          v-slot="{ errors }"
                          :name="
                            $t(
                              'BusinessSetting.AccountOrderSettings.lower_percent'
                            )
                          "
                          :rules="{
                            min_value: {
                              min: 0,
                            },
                          }"
                        >
                          <v-text-field
                            v-model="settingValues.sorting_out_lower_percent"
                            :disabled="businessPermission.find((d) => d == 5) ? false : true"
                            dense
                            single-line
                            suffix="%"
                            type="number"
                            style="max-width: 150px"
                            :error-messages="errors"
                          >
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-divider
                      v-if="
                        $permission.permissionAllow(
                          'StockOuts',
                          'commonSortingOut'
                        )
                      "
                    />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.autoCancelOrderTime"
                          ) + $t("Global.colon")
                        }}
                        <br/>
                        <span class="caption">
                          {{ $t("BusinessSetting.AccountOrderSettings.autoCancelOrderTimeHint") }}
                        </span>
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          v-model="settingValues.auto_cancel_time_type"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                          @change="
                            auto_cancel_order_period = '';
                            auto_cancel_order_clock = '';
                          "
                        >
                          <v-radio :key="1" :value="1">
                            <template v-slot:label>
                              {{
                                $t(
                                  "BusinessSetting.AccountOrderSettings.autoCancelTimeType.period"
                                )
                              }}
                              <v-select
                                v-model="auto_cancel_order_period"
                                :disabled="businessPermission.find((d) => d == 5) ? false : true"
                                :items="timeQuantumSelect"
                                item-text="value"
                                item-value="key"
                                clearable
                                dense
                                class="my-4 ml-2"
                                style="max-width: 220px"
                              ></v-select> </template
                          ></v-radio>
                          <v-radio :key="2" :value="2">
                            <template v-slot:label>
                              {{
                                $t(
                                  "BusinessSetting.AccountOrderSettings.autoCancelTimeType.time"
                                )
                              }}
                              <SearcherDatetime
                                class="my-n2 ml-2 pb-1"
                                v-model="auto_cancel_order_clock"
                                :disabled="businessPermission.find((d) => d == 5) ? false : true"
                                type="minutes"
                                single-line
                                dense
                                hide-details
                                hide-icon
                                style="max-width: 220px"
                                :minute-step="5"
                              >
                              </SearcherDatetime
                            ></template>
                          </v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center" v-if="false">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.shopAddressEdit.title"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.shop_address_edit"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                        >
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.AccountOrderSettings.shopAddressEdit.on'
                              )
                            "
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.AccountOrderSettings.shopAddressEdit.off'
                              )
                            "
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.pay_first_wait_pay_no_order"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.pay_first_wait_pay_no_order"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.AccountOrderSettings.no_pay_first_auto_confirm"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-text-field
                          v-model="settingValues.no_pay_first_auto_confirm"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                          dense
                          single-line
                          :suffix="
                            $t('BusinessSetting.AccountOrderSettings.minute')
                          "
                          type="number"
                          style="max-width: 150px"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                              "BusinessSetting.AccountOrderSettings.order_index_express_display"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.order_index_express_display"
                          :disabled="businessPermission.find((d) => d == 5) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- 商品管理相关设置 -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("BusinessSetting.MaterialManagementSetting.ObjectName") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.MaterialManagementSetting.materialNameDisplayType.title"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.material_name_display_type"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                          :hint="
                            $t(
                              'BusinessSetting.MaterialManagementSetting.materialNameDisplayType.hint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.MaterialManagementSetting.materialNameDisplayType.one'
                              )
                            "
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.MaterialManagementSetting.materialNameDisplayType.two'
                              )
                            "
                            :key="2"
                            :value="2"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.MaterialManagementSetting.materialNameDisplayType.three'
                              )
                            "
                            :key="3"
                            :value="3"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.MaterialManagementSetting.materialNameDisplayType.four'
                              )
                            "
                            :key="4"
                            :value="4"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.MaterialManagementSetting.materialAutoCodeSetting.title"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="materialAutoCodeSetting.auto_code"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                          :hint="
                            $t(
                              'BusinessSetting.MaterialManagementSetting.materialAutoCodeSetting.hint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="2"
                            value="2"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="1"
                            value="1"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <div v-if="materialAutoCodeSetting.auto_code == 2">
                      <v-row align="center" class="mx-3">
                        <v-col cols="3" class="font-weight-bold text-left">
                          {{
                            $t(
                              "BusinessSetting.MaterialManagementSetting.materialAutoCodeSetting.followCategory"
                            ) + $t("Global.colon")
                          }}
                        </v-col>
                        <v-col cols="9" md="7">
                          <v-radio-group
                            row
                            v-model="materialAutoCodeSetting.follow_category"
                            :disabled="businessPermission.find((d) => d == 6) ? false : true"
                          >
                            <v-radio
                              :label="$t('BusinessSetting.RadioField.on')"
                              :key="1"
                              value="1"
                            />
                            <v-radio
                              :label="$t('BusinessSetting.RadioField.off')"
                              :key="0"
                              value="0"
                            />
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <v-row
                        align="center"
                        class="mx-3"
                        v-if="!Number(materialAutoCodeSetting.follow_category)"
                      >
                        <v-col cols="3" class="font-weight-bold text-left">
                          {{
                            $t(
                              "BusinessSetting.MaterialManagementSetting.materialAutoCodeSetting.customPrefix"
                            ) + $t("Global.colon")
                          }}
                        </v-col>
                        <v-col cols="9" md="7">
                          <ValidationProvider
                            v-slot="{ errors }"
                            :name="
                              $t(
                                'BusinessSetting.MaterialManagementSetting.materialAutoCodeSetting.customPrefix'
                              )
                            "
                            rules="max:10"
                          >
                            <v-text-field
                              v-model="materialAutoCodeSetting.fixed_prefix"
                              :disabled="businessPermission.find((d) => d == 6) ? false : true"
                              dense
                              :error-messages="errors"
                            />
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row align="center" class="mx-3">
                        <v-col cols="3" class="font-weight-bold text-left">
                          {{
                            $t(
                              "BusinessSetting.MaterialManagementSetting.materialAutoCodeSetting.initialSerialNumberLength"
                            ) + $t("Global.colon")
                          }}
                        </v-col>
                        <v-col cols="9" md="7">
                          <v-select
                            v-model="iniNumberLengthValue"
                            :items="iniNumberLengthItem"
                            :disabled="businessPermission.find((d) => d == 6) ? false : true"
                            item-text="key"
                            item-value="value"
                            dense
                            class="my-4"
                            style="max-width: 220px"
                            :hint="
                              $t(
                                'BusinessSetting.MaterialManagementSetting.materialAutoCodeSetting.initialSerialNumberLengthHint'
                              )
                            "
                            persistent-hint
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row align="center" class="mx-3">
                        <v-col cols="3" class="font-weight-bold text-left">
                          {{
                            $t(
                              "BusinessSetting.MaterialManagementSetting.materialAutoCodeSetting.initialSerialNumber"
                            ) + $t("Global.colon")
                          }}
                        </v-col>
                        <v-col cols="9" md="7">
                          <div class="row-center ini_number_input_wrapper">
                            <v-text-field
                              v-for="(item, index) in iniNumber"
                              :key="index"
                              v-model="item.num"
                              :disabled="businessPermission.find((d) => d == 6) ? false : true"
                              :id="'initialize' + index"
                              class="ini_number_input_box row-center input-center"
                              type="number"
                              @focus="adjust(index)"
                              @keydown="
                                inputDirection(index);
                                activeInput = index;
                              "
                              @input="inputFinish(index)"
                            ></v-text-field>
                          </div>
                        </v-col>
                      </v-row>
                    </div>

                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.MaterialManagementSetting.materialImage"
                          )
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-checkbox
                          v-model="settingValues.material_image"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                          class=""
                          :label="
                            $t(
                              'BusinessSetting.MaterialManagementSetting.materialImageLabel'
                            )
                          "
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.MaterialManagementSetting.productDateSetting"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.product_date_setting"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                          :hint="
                            $t(
                              'BusinessSetting.MaterialManagementSetting.productDateSettingHint'
                            )
                          "
                          persistent-hint
                          @change="
                            productDateSetting
                              ? (productDateSettingDialog = true)
                              : ''
                          "
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row
                      align="center"
                      v-if="settings && settings.stock_position_setting"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.MaterialManagementSetting.expiredBatchPickSetting"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.expired_batch_pick_setting"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                          :hint="
                            $t(
                              'BusinessSetting.MaterialManagementSetting.expiredBatchPickSettingHint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider
                      v-if="settings && settings.stock_position_setting"
                    />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.MaterialManagementSetting.materialForceBestbefore"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.material_force_bestbefore"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                          :hint="
                            $t(
                              'BusinessSetting.MaterialManagementSetting.materialForceBestbeforeHint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider v-if="settingValues.material_force_bestbefore" />
                    <v-row
                      align="center"
                      v-if="settingValues.material_force_bestbefore"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.MaterialManagementSetting.bestbeforeDefaultDays"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-text-field
                          v-model="settingValues.bestbefore_default_days"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                          single-line
                          style="max-width: 150px"
                          :suffix="$t('BusinessSetting.day')"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.MaterialManagementSetting.materialForceNearday"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.nearday"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                          :hint="
                            $t(
                              'BusinessSetting.MaterialManagementSetting.materialForceNeardayHint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.MaterialManagementSetting.lastPurchasePrice"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.last_purchase_price"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                          :hint="
                            $t(
                              'BusinessSetting.MaterialManagementSetting.lastPurchasePriceHint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.MaterialManagementSetting.orderDetailMemo"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.order_detail_memo"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                          :hint="
                            $t(
                              'BusinessSetting.MaterialManagementSetting.orderDetailMemoHint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.MaterialManagementSetting.showPriceToShop"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.show_price_to_shop"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                          :hint="
                            $t(
                              'BusinessSetting.MaterialManagementSetting.showPriceToShopHint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.MaterialManagementSetting.materialGroupEnable"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.material_group_enable"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.MaterialManagementSetting.supplierTrustee"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="material_for_supplier"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                          :hint="
                            $t(
                              'BusinessSetting.MaterialManagementSetting.supplierTrusteeHint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.MaterialManagementSetting.templateEditMaterialEnable"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.template_edit_material_enable"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                          :hint="
                            $t(
                              'BusinessSetting.MaterialManagementSetting.templateEditMaterialEnableHint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <!-- 是否启用商品第三方编码 -->
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.MaterialManagementSetting.materialExtCodeEnable"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.material_ext_code_enable"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <!-- 自动标配商品是否同时批量上架 -->
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                              "BusinessSetting.MaterialManagementSetting.autoRulerMaterialShelveCheck"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.auto_ruler_material_shelve_check"
                          :disabled="businessPermission.find((d) => d == 6) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- 仓库管理设置 -->
            <v-expansion-panel v-if="settings && accountInfo">
              <v-expansion-panel-header>
                {{ $t("BusinessSetting.StockManagementSetting.ObjectName") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row
                      align="center"
                      v-if="settings && settings.stock_position_setting"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.StockManagementSetting.deliveryAreaSetting"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-checkbox
                          v-model="settingValues.distribution_district_unique"
                          :disabled="businessPermission.find((d) => d == 7) ? false : true"
                          :label="
                            $t(
                              'BusinessSetting.StockManagementSetting.deliveryAreaLabel'
                            )
                          "
                          :hint="
                            $t(
                              'BusinessSetting.StockManagementSetting.deliveryAreaSettingHint'
                            )
                          "
                          persistent-hint
                          :true-value="1"
                          :false-value="0"
                          @change="updateDistributionDistrictUnique()"
                        ></v-checkbox>
                      </v-col>
                      <v-divider
                        v-if="
                          settings &&
                          settings.stock_position_setting &&
                          settingValues.distribution_district_unique
                        "
                      />
                    </v-row>
                    <v-row
                      align="center"
                      v-if="settingValues.distribution_district_unique"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.StockManagementSetting.deliveryAreaAutoAdd"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.distribution_district_auto_add"
                          :disabled="businessPermission.find((d) => d == 7) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider
                      v-if="settings && settings.stock_position_setting"
                    />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.StockManagementSetting.stockHistoryCreateTimeSetting"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-select
                          v-model="settingValues.stock_history_create_time"
                          :disabled="businessPermission.find((d) => d == 7) ? false : true"
                          :items="timeQuantumSelect"
                          item-text="value"
                          item-value="key"
                          clearable
                          dense
                          class="my-4"
                          style="max-width: 220px"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.StockManagementSetting.outAddCheckNegative"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.out_add_check_negative"
                          :disabled="businessPermission.find((d) => d == 7) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider
                      v-if="settings && settings.stock_position_setting"
                    />
                    <v-row
                      align="center"
                      v-if="settings && settings.stock_position_setting"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.StockManagementSetting.distributionUserEnable"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.distribution_user_enable"
                          :disabled="businessPermission.find((d) => d == 7) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.StockManagementSetting.stock_take_out_from_batch"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.stock_take_out_from_batch"
                          :disabled="businessPermission.find((d) => d == 7) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.StockManagementSetting.production_in_price_setting"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.production_in_price_setting"
                          :disabled="businessPermission.find((d) => d == 7) ? false : true"
                        >
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.StockManagementSetting.production_in_price_types.produciton_in_price'
                              )
                            "
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.StockManagementSetting.production_in_price_types.other_cost'
                              )
                            "
                            :key="2"
                            :value="2"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row
                      align="center"
                      v-if="
                        $permission.permissionAllow('DeliveryPoints', 'index')
                      "
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.StockManagementSetting.deliveryPointEnable"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.delivery_point"
                          :disabled="businessPermission.find((d) => d == 7) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider
                      v-if="
                        $permission.permissionAllow('DeliveryPoints', 'index')
                      "
                    />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.StockManagementSetting.other_in_price_setting"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.other_in_price_setting"
                          :disabled="businessPermission.find((d) => d == 7) ? false : true"
                        >
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.StockManagementSetting.other_price_setting.inventory_price'
                              )
                            "
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.StockManagementSetting.other_price_setting.lase_price'
                              )
                            "
                            :key="2"
                            :value="2"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.StockManagementSetting.other_out_price_setting"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.other_out_price_setting"
                          :disabled="businessPermission.find((d) => d == 7) ? false : true"
                        >
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.StockManagementSetting.other_price_setting.inventory_price'
                              )
                            "
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.StockManagementSetting.other_price_setting.lase_price'
                              )
                            "
                            :key="2"
                            :value="2"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.StockManagementSetting.return_out_price_setting"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.return_out_price_setting"
                          :disabled="businessPermission.find((d) => d == 7) ? false : true"
                        >
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.StockManagementSetting.other_price_setting.default_price'
                              )
                            "
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.StockManagementSetting.other_price_setting.inventory_price'
                              )
                            "
                            :key="2"
                            :value="2"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.StockManagementSetting.other_price_setting.lase_price'
                              )
                            "
                            :key="3"
                            :value="3"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.StockManagementSetting.requisition_express_price"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.requisition_express_price"
                          :disabled="businessPermission.find((d) => d == 7) ? false : true"
                        >
                         <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider v-if="settingValues && settingValues.requisition_express_price" />
                    <v-row align="center" v-if="settingValues && settingValues.requisition_express_price">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{ $t("BusinessSetting.StockManagementSetting.requisition_express_display") + $t("Global.colon") }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                            row
                            v-model="settingValues.requisition_express_display"
                            :disabled="businessPermission.find((d) => d == 7) ? false : true"
                        >
                          <v-radio
                              :label="$t('BusinessSetting.RadioField.on')"
                              :key="1"
                              :value="1"
                          />
                          <v-radio
                              :label="$t('BusinessSetting.RadioField.off')"
                              :key="0"
                              :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{ $t("BusinessSetting.StockManagementSetting.requisition_in_no_modify.title") + $t("Global.colon") }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.requisition_in_no_modify"
                          :disabled="businessPermission.find((d) => d == 7) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.StockManagementSetting.requisition_in_no_modify.on')"
                            :key="0"
                            :value="0"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.StockManagementSetting.requisition_in_no_modify.off')"
                            :key="1"
                            :value="1"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{ $t("BusinessSetting.StockManagementSetting.auto_out_setting.auto_out") + $t("Global.colon") }}
                        <br />
                        <v-btn
                          v-if="autoOutSetting.auto_out == 1"
                          color="primary"
                          x-small
                          outlined
                          @click="autoOutSettingEditFlg = true"
                        >
                          {{ $t("CRUD.edit") }}
                        </v-btn>
                      </v-col>
                      <v-col cols="9">
                        <v-radio-group
                          row
                          v-model="autoOutSetting.auto_out"
                          :disabled="businessPermission.find((d) => d == 7) ? false : true"
                          persistent-hint
                          :hint="
                            $t(
                              'BusinessSetting.StockManagementSetting.auto_out_setting.auto_out_hint'
                            )
                          "
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row v-if="autoOutSetting.auto_out == 1">
                      <v-col cols="3" class="font-weight-bold text-left my-4">
                        {{ $t("BusinessSetting.StockManagementSetting.auto_out_setting.in_type") + $t("Global.colon") }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row class="ml-0">
                          <v-radio-group
                              row
                              v-model="autoOutSetting.in_type"
                              :disabled="businessPermission.find((d) => d == 7) && autoOutSettingEditFlg ? false : true"
                          >
                            <v-radio
                              :label="$t('StockOrderIN.types.other_stock_in')"
                              :key="1"
                              :value="1"
                            />
                            <v-radio
                              :label="$t('StockOrderIN.types.stock_taking_in')"
                              :key="2"
                              :value="2"
                            />
                          </v-radio-group>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row v-if="autoOutSetting.auto_out == 1">
                      <v-col cols="3" class="font-weight-bold text-left my-4">
                        {{ $t("BusinessSetting.StockManagementSetting.auto_out_setting.in_type_price") + $t("Global.colon") }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row class="ml-0">
                          <v-radio-group
                            row
                            v-model="autoOutSetting.in_type_price"
                            :disabled="businessPermission.find((d) => d == 7) && autoOutSettingEditFlg ? false : true"
                          >
                            <v-radio
                              :label="$t('BusinessSetting.RadioField.on')"
                              :key="1"
                              :value="1"
                            />
                            <v-radio
                              :label="$t('BusinessSetting.RadioField.off')"
                              :key="0"
                              :value="0"
                            />
                            <v-radio
                              :label="$t('BusinessSetting.StockManagementSetting.auto_out_setting.in_type_price_last')"
                              :key="2"
                              :value="2"
                            />
                          </v-radio-group>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row v-if="autoOutSetting.auto_out == 1">
                      <v-col cols="3" class="font-weight-bold text-left mt-3">
                        {{ $t("BusinessSetting.StockManagementSetting.auto_out_setting.out_time") + $t("Global.colon") }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-select
                          v-model="autoOutSetting.out_time"
                          :disabled="businessPermission.find((d) => d == 7) && autoOutSettingEditFlg ? false : true"
                          :items="autoOutTime"
                          item-text="value"
                          item-value="key"
                          clearable
                          dense
                          style="max-width: 220px"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row v-if="autoOutSetting.auto_out == 1">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{ $t("BusinessSetting.StockManagementSetting.auto_out_setting.stock") + $t("Global.colon") }}
                        <br />
                        <v-btn
                          v-if="businessPermission.find((d) => d == 7) && autoOutSettingEditFlg"
                          color="primary"
                          class="my-1 mr-3"
                          x-small
                          outlined
                          @click="autoOutStocksDialog = true"
                        >
                          {{ $t("CRUD.chooseInfo", [$t("Stock.ObjectName")]) }}
                        </v-btn>
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-data-table
                          :headers="stockHeaders"
                          :items="autoOutStocks"
                          multi-sort
                          class="elevation-1 px-4 pt-2"
                          disable-pagination
                          hide-default-footer
                          fixed-header
                        >
                          <template v-slot:header.actions>
                            <!-- 删除按钮 -->
                            <v-btn
                              v-if="businessPermission.find((d) => d == 7) && autoOutSettingEditFlg"
                              small
                              text
                              class="danger--text pa-0"
                              @click="autoOutStocks = []"
                            >
                              <v-icon>fa-times</v-icon>
                            </v-btn>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <!-- 删除商品按钮 -->
                            <v-btn
                              v-if="businessPermission.find((d) => d == 7) && autoOutSettingEditFlg"
                              small
                              text
                              class="danger--text pa-0"
                              @click="
                                autoOutStocks.splice(
                                  autoOutStocks.findIndex(
                                    (stock) => stock.id == item.id
                                  ),
                                  1
                                )
                              "
                            >
                              <v-icon>fa-times</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row v-if="autoOutSetting.auto_out == 1">
                      <v-col cols="3" class="font-weight-bold text-left my-4">
                        {{ $t("BusinessSetting.StockManagementSetting.auto_out_setting.type") + $t("Global.colon") }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row class="ml-0">
                          <v-checkbox
                            :disabled="businessPermission.find((d) => d == 7) && autoOutSettingEditFlg ? false : true"
                            v-model="autoOutTypeOrder"
                            class=""
                            :label="$t('StockOrderOUT.types.order')"
                            :true-value="1"
                            :false-value="0"
                           ></v-checkbox>
                           <v-checkbox
                            :disabled="businessPermission.find((d) => d == 7) && autoOutSettingEditFlg ? false : true"
                            v-model="autoOutTypeRequisition"
                            class="ms-2"
                            :label="$t('StockOrderOUT.types.requisition')"
                            :true-value="1"
                            :false-value="0"
                           ></v-checkbox>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row v-if="autoOutSetting.auto_out == 1">
                      <v-col cols="3" class="font-weight-bold text-left my-4">
                        {{ $t("BusinessSetting.StockManagementSetting.auto_out_setting.date_type") + $t("Global.colon") }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row class="ml-0">
                          <v-radio-group
                            row
                            v-model="autoOutSetting.date_type"
                            :disabled="businessPermission.find((d) => d == 7) && autoOutSettingEditFlg ? false : true"
                          >
                            <v-radio
                              :label="$t('StockOrderOUT.Fields.created_time')"
                              :key="1"
                              :value="1"
                            />
                            <v-radio
                              :label="$t('StockOrderOUT.Fields.order_time')"
                              :key="2"
                              :value="2"
                            />
                            <v-radio
                              :label="$t('StockOrderOUT.Fields.actual_time')"
                              :key="3"
                              :value="3"
                            />
                            <v-radio
                              :label="$t('StockOrderOUT.Fields.finished_time')"
                              :key="4"
                              :value="4"
                            />
                            <v-radio
                              :label="$t('StockOrderOUT.Fields.expect_time')"
                              :key="5"
                              :value="5"
                            />
                          </v-radio-group>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row v-if="autoOutSetting.auto_out == 1">
                      <v-col cols="3" class="font-weight-bold text-left my-4">
                        {{ $t("BusinessSetting.StockManagementSetting.auto_out_setting.date_day") + $t("Global.colon") }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row class="ml-0">
                          <v-text-field
                              v-model="autoOutSetting.date_day"
                              :disabled="(businessPermission.find((d) => d == 7) && autoOutSettingEditFlg) ? false : true"
                              single-line
                              type="number"
                              min="0"
                              :suffix="$t('MaterialCoupons.Unit.days')"
                              style="max-width: 150px"
                              @blur="
                                autoOutSetting.date_day != ''
                                  ? (autoOutSetting.date_day = $numberFormatter.formatNoDot(
                                      autoOutSetting.date_day
                                    ))
                                  : ''
                              "
                          >
                          </v-text-field>
                        </v-row>
                      </v-col>
                    </v-row>
                 </v-card-text>
               </v-card>
             </v-expansion-panel-content>
           </v-expansion-panel>
           <!-- 智能采购设置 -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{
                  $t("BusinessSetting.IntelligentPurchaseSetting.ObjectName")
                }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <!-- TODO:num_type的设置暂时没有地方用，先跳过,接口后续需补这个字段 -->
                    <v-row align="center" v-if="intelligentPurchase.num_type">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.IntelligentPurchaseSetting.stockLimit.title"
                          ) + "TODO"
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="intelligentPurchase.stock_limit"
                          :disabled="businessPermission.find((d) => d == 8) ? false : true"
                        >
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.IntelligentPurchaseSetting.stockLimit.max'
                              )
                            "
                            :key="1"
                            value="1"
                          />
                          <v-radio
                            :label="
                              $t(
                                'BusinessSetting.IntelligentPurchaseSetting.stockLimit.min'
                              )
                            "
                            :key="2"
                            value="2"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider v-if="intelligentPurchase.num_type" />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.IntelligentPurchaseSetting.upPercent"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <ValidationProvider
                          v-slot="{ errors }"
                          :name="
                            $t(
                              'BusinessSetting.IntelligentPurchaseSetting.upPercent'
                            )
                          "
                          :rules="{
                            min_value: {
                              min: 0,
                            },
                          }"
                        >
                          <v-text-field
                            v-model="intelligentPurchase.up_percent"
                            :disabled="businessPermission.find((d) => d == 8) ? false : true"
                            dense
                            single-line
                            suffix="%"
                            type="number"
                            style="max-width: 150px"
                            :error-messages="errors"
                          >
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center" class="mt-3">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.IntelligentPurchaseSetting.supplierIdSetting"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <span class="d-flex" style="width: 220px">
                          <SearcherSupplier
                            v-model="intelligentPurchase.supplier"
                            :isDisabled="businessPermission.find((d) => d == 8) ? false : true"
                            no-label
                            single-line
                            dense
                            hide-details
                            class="d-inline"
                            style="width: 220px"
                          />
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- 采购设置 -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("BusinessSetting.PurchaseSetting.ObjectName") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.PurchaseSetting.purchase_examine_percent"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <ValidationProvider
                          v-slot="{ errors }"
                          :name="
                            $t(
                              'BusinessSetting.IntelligentPurchaseSetting.upPercent'
                            )
                          "
                          :rules="{
                            min_value: {
                              min: 0,
                            },
                          }"
                        >
                          <v-text-field
                            v-model="settingValues.purchase_examine_percent"
                            :disabled="businessPermission.find((d) => d == 9) ? false : true"
                            dense
                            single-line
                            suffix="%"
                            type="number"
                            style="max-width: 150px"
                            :error-messages="errors"
                          >
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.PurchaseSetting.qualify_report_enable"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.qualify_report_enable"
                          :disabled="businessPermission.find((d) => d == 9) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider
                      v-if="
                        settingValues && settingValues.qualify_report_enable
                      "
                    />
                    <v-row
                      align="center"
                      v-if="
                        settingValues && settingValues.qualify_report_enable
                      "
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.PurchaseSetting.out_qualify_report_enable"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.out_qualify_report_enable"
                          :disabled="businessPermission.find((d) => d == 9) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.PurchaseSetting.show_purchase_address"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.show_purchase_address"
                          :disabled="businessPermission.find((d) => d == 9) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.PurchaseSetting.purchase_subtotal"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.purchase_subtotal"
                          :disabled="businessPermission.find((d) => d == 9) ? false : true"
                          :hint="$t('BusinessSetting.PurchaseSetting.purchase_subtotal_hint')"
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row
                      align="center"
                      v-if="
                        accountInfo &&
                        accountInfo.version &&
                        accountInfo.version.stock_type != 1
                      "
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.PurchaseSetting.supplier_self_purchase"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.supplier_self_purchase"
                          :disabled="businessPermission.find((d) => d == 9) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- 应收应付设置 -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{
                  $t("BusinessSetting.ResourcePaymentReceiptSetting.ObjectName")
                }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row
                      align="center"
                      v-if="
                        $permission.permissionAllow('FinanceBills', 'index')
                      "
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.financeBillEnable"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="financeBillEnable"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider
                      v-if="
                        $permission.permissionAllow('FinanceBills', 'index')
                      "
                    />
                    <!-- <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.receiptShowCategoryEnable"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.receipt_show_category_enable"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider /> -->
                    <v-row
                      align="center"
                      v-if="
                        $permission.permissionAllow('Receipt', 'useTaxSetting')
                      "
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.useTax"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.use_tax"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          dense
                          :hint="$t('BusinessSetting.unTurnOffMassage')"
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider
                      v-if="
                        $permission.permissionAllow('Receipt', 'useTaxSetting')
                      "
                    />
                    <v-row
                      class="my-3"
                      v-if="
                        $permission.permissionAllow(
                          'Receipt',
                          'useTaxSetting'
                        ) && settingValues.use_tax
                      "
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.taxInfo"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-btn
                          class="primary"
                          small
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          @click="taxTabledisplay = true"
                        >
                          {{
                            $t(
                              "BusinessSetting.ResourcePaymentReceiptSetting.taxInfoSetting"
                            )
                          }}
                        </v-btn>
                        <div v-if="taxTabledisplay" class="mt-2">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                x-small
                                fab
                                dark
                                color="primary"
                                class="px-2 me-2 mb-1"
                                :disabled="businessPermission.find((d) => d == 10) ? false : true"
                                @click="editTaxDialog = true"
                              >
                                <v-icon x-small dark>fa-plus</v-icon>
                              </v-btn>
                            </template>
                            <span>
                              {{
                                $t("CRUD.newInfo", [
                                  $t(
                                    "BusinessSetting.ResourcePaymentReceiptSetting.taxInfoFields.ObjectName"
                                  ),
                                ])
                              }}
                            </span>
                          </v-tooltip>
                          <v-data-table
                            :headers="taxHeaders"
                            :items="taxList"
                            :loading="loading"
                            multi-sort
                            class="elevation-1 px-4 pt-1"
                          >
                            <template v-slot:header.actions="{ header }">
                              {{ header.text }}
                              <v-icon x-small>fa-sliders-h</v-icon>
                            </template>
                            <template v-slot:item.tax="{ item }">
                              {{ item.tax }}
                              {{ $t("Global.rate") }}
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    color="primary"
                                    class="px-1 py-4 me-1"
                                    :disabled="businessPermission.find((d) => d == 10) ? false : true"
                                    @click="
                                      currentTax = JSON.parse(
                                        JSON.stringify(item)
                                      );
                                      editTaxDialog = true;
                                    "
                                    >fa-pencil-alt
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t("CRUD.editInfo", [
                                      $t(
                                        "BusinessSetting.ResourcePaymentReceiptSetting.taxInfoFields.ObjectName"
                                      ),
                                    ])
                                  }}
                                </span>
                              </v-tooltip>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    color="danger"
                                    class="px-1 me-1"
                                    :disabled="businessPermission.find((d) => d == 10) ? false : true"
                                    @click="
                                      currentTax = JSON.parse(
                                        JSON.stringify(item)
                                      );
                                      delTaxDialog = true;
                                    "
                                    >fa-trash-alt
                                  </v-icon>
                                </template>
                                <span>
                                  {{
                                    $t("CRUD.deleteInfo", [
                                      $t(
                                        "BusinessSetting.ResourcePaymentReceiptSetting.taxInfoFields.ObjectName"
                                      ),
                                    ])
                                  }}
                                </span>
                              </v-tooltip>
                            </template>
                          </v-data-table>
                        </div>
                      </v-col>
                    </v-row>
                    <v-divider
                      v-if="
                        $permission.permissionAllow(
                          'Receipt',
                          'useTaxSetting'
                        ) && settingValues.use_tax
                      "
                    />
                    <v-row align="center" class="mt-3">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.resourcePaymentReceiptCredential"
                          )
                        }}
                      </v-col>
                    </v-row>
                    <v-row align="center" class="mx-3">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.billTypeShop"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-select
                          v-if="
                            $permission.permissionAllow(
                              'Receipt',
                              'updateCredentialType'
                            )
                          "
                          v-model="billCredentialType.shop_bill"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          :items="ShopBillArr"
                          @change="clearExpressSetting('shop_bill')"
                          item-text="text"
                          item-value="type"
                          dense
                          class="mb-n5"
                          style="max-width: 220px"
                        >
                        </v-select>
                        <span v-else>
                          {{
                            $t(
                              "BusinessSetting.ResourcePaymentReceiptSetting.stockOrderOutType"
                            )
                          }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      class="mx-3"
                      v-if="billCredentialType.shop_bill == '4'"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.stock_order_express_edit_enable"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.stock_order_express_edit_enable"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          dense
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      class="mx-3"
                      v-if="billCredentialType.shop_bill == '12'"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.finance_bill_examine_enable"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.finance_bill_examine_enable"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          dense
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      class="mx-3"
                      v-if="billCredentialType.shop_bill == '20'"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.examine_order_express_edit_enable"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.examine_order_express_edit_enable"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          @change="
                            clearExpressSetting(
                              'examine_order_express_edit_enable'
                            )
                          "
                          dense
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      class="mx-3"
                      v-if="
                        $permission.permissionAllow(
                          'Receipt',
                          'updateCredentialType'
                        ) && billCredentialType.shop_bill == '19'
                      "
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.orderEditable"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="billCredentialType.order_edit"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          dense
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      class="mx-3"
                      v-if="billCredentialType.shop_bill == '20'"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.examineAutoIn"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="billCredentialType.examine_auto_in"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          dense
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row align="center" class="mx-3">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.billTypeReturn"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col v-if="!financeBillEnable" cols="9" md="7">
                        <span>
                          {{
                            $t(
                              "BusinessSetting.ResourcePaymentReceiptSetting.inTypeReturn"
                            )
                          }}
                        </span>
                      </v-col>
                      <v-col v-else cols="9" md="7">
                        <v-select
                          v-if="
                            $permission.permissionAllow(
                              'Receipt',
                              'updateCredentialType'
                            )
                          "
                          v-model="billCredentialType.return_bill"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          :items="ReturnBillArr"
                          item-text="text"
                          item-value="type"
                          dense
                          class="mb-n5"
                          style="max-width: 220px"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row align="center" class="mx-3">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.billTypeSupplier"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col v-if="!financeBillEnable" cols="9" md="7">
                        <span>
                          {{
                            $t(
                              "BusinessSetting.ResourcePaymentReceiptSetting.inTypeSupplier"
                            )
                          }}
                        </span>
                      </v-col>
                      <v-col v-else cols="9" md="7">
                        <v-select
                          v-if="
                            $permission.permissionAllow(
                              'Receipt',
                              'updateCredentialType'
                            )
                          "
                          v-model="billCredentialType.purchase_bill"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          :items="SupplierBillArr"
                          item-text="text"
                          item-value="type"
                          dense
                          class="mb-n5"
                          style="max-width: 220px"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row align="center" class="mx-3">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.billTypeSupplierReturnOrder"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col v-if="!financeBillEnable" cols="9" md="7">
                        <span>
                          {{
                            $t(
                              "BusinessSetting.ResourcePaymentReceiptSetting.OutTypeNormalSupplierReturnOrder"
                            )
                          }}
                        </span>
                      </v-col>
                      <v-col v-else cols="9" md="7">
                        <v-select
                          v-if="
                            $permission.permissionAllow(
                              'Receipt',
                              'updateCredentialType'
                            )
                          "
                          v-model="billCredentialType.purchase_return_bill"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          :items="PurchaseReturnBillArr"
                          item-text="text"
                          item-value="type"
                          dense
                          class="mb-n5"
                          style="max-width: 220px"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row align="center" class="mx-3">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                              "BusinessSetting.ResourcePaymentReceiptSetting.purchaseReturnOnlyBill"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col v-if="!financeBillEnable" cols="9" md="7">
                        <span>
                          {{
                            $t(
                                "BusinessSetting.ResourcePaymentReceiptSetting.OutTypeNormalSupplierReturnOrder"
                            )
                          }}
                        </span>
                      </v-col>
                      <v-col v-else cols="9" md="7">
                        <v-select
                            v-if="
                            $permission.permissionAllow(
                              'Receipt',
                              'updateCredentialType'
                            )
                          "
                            v-model="billCredentialType.purchase_return_only_bill"
                            :disabled="businessPermission.find((d) => d == 10) ? false : true"
                            :items="PurchaseReturnOnlyBillArr"
                            item-text="text"
                            item-value="type"
                            dense
                            class="mb-n5"
                            style="max-width: 220px"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row align="center" class="mx-3">
                      <v-col cols="3" class="font-weight-bold text-left">
                      </v-col>
                      <v-col cols="9" md="7">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.resourcePaymentReceiptCredentialHint"
                          )
                        }}
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.refundWay"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.cancel_auto_refund"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          :hint="
                            $t(
                              'BusinessSetting.ResourcePaymentReceiptSetting.refundWayHint'
                            )
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row
                      align="center"
                      v-if="settings && !settings.sub_account_enable"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.expressFeeActual"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.bill_express_fee_actual"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          @change="
                            clearExpressSetting('bill_express_fee_actual')
                          "
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.yes')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.no')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.paidCloseOrderFee"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.paid_close_order_fee"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <!-- 自动退款 -->
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.autoRefundToBalance"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="autoRefundToBalance.is_enable"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider v-if="autoRefundToBalance.is_enable == 1" />
                    <!-- 账单自动退款订单状态 -->
                    <v-row
                      align="center"
                      v-if="autoRefundToBalance.is_enable == 1"
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.order_status"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="autoRefundToBalance.order_status"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.confirmed')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="
                              $t('BusinessSetting.RadioField.distributions')
                            "
                            :key="2"
                            :value="2"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.complete')"
                            :key="3"
                            :value="3"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-divider
                      v-if="
                        $permission.permissionAllow(
                          'Shops',
                          'shopBalanceSnapshots'
                        )
                      "
                    />
                    <!-- 门店余额历史自动生成时间设置 -->
                    <v-row
                      align="center"
                      v-if="
                        $permission.permissionAllow(
                          'Shops',
                          'shopBalanceSnapshots'
                        )
                      "
                    >
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{
                          $t(
                            "BusinessSetting.ResourcePaymentReceiptSetting.shop_balance_snapshot_time"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-select
                          v-model="settingValues.shop_balance_snapshot_time"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          :items="timeQuantumSelect"
                          item-text="value"
                          item-value="key"
                          clearable
                          dense
                          class="my-4"
                          style="max-width: 220px"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <!-- 现金折扣 -->
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{ $t("BusinessSetting.ResourcePaymentReceiptSetting.cash_discount") + $t("Global.colon") }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.cash_discount"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <!-- 应收应付统计历史自动生成 -->
                    <v-divider />
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-left">
                        {{ $t("BusinessSetting.ResourcePaymentReceiptSetting.bill_analyze_history_auto_add") + $t("Global.colon") }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="settingValues.bill_analyze_history_auto_add"
                          :disabled="businessPermission.find((d) => d == 10) ? false : true"
                          persistent-hint
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </ValidationObserver>
      </v-sheet>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn color="success" block @click="saveSettings()">
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.saveInfo", [$t("BusinessSetting.ObjectName")]) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>

    <v-dialog v-model="templateConfigurationDialog" scrollable width="600px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("BusinessSetting.AppAndWxApp.shopRegister.template_setting") }}
          <v-spacer />
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="templateConfigurationDialog = false"
              >
                fa-times
              </v-icon>
            </template>
            <span>{{ $t("$vuetify.close") }}</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text style="height: 500px">
          <ValidationObserver ref="templateConfigurationDialogObserver">
            <v-treeview
              class="py-2"
              v-model="districtTree"
              :items="districts"
              item-key="code"
              item-children="districts"
              :open="districtsOpen"
              hoverable
              activatable
              return-object
            >
              <template v-slot:label="{ item }">
                <v-row no-gutters align="center">
                  {{ item.name }}
                  <v-spacer />
                  <v-divider vertical class="mx-2" />
                  <ValidationProvider v-slot="{ errors }" rules="trequired">
                    <v-autocomplete
                      color="primary"
                      v-model="item.templateSelected"
                      :items="templates"
                      :loading="templatesLoading"
                      :search-input.sync="item.templateSearch"
                      item-text="template_name"
                      item-value="id"
                      item-disabled="disabled"
                      :label="$t('Template.ObjectName')"
                      return-object
                      single-line
                      dense
                      style="margin-left: auto; margin-right: auto"
                      :error-messages="errors"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-row>
              </template>
            </v-treeview>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            class="elevation-1"
            @click="templateConfigurationDialog = false"
          >
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" @click="saveDistrictBindTemplates()">
            {{ $t("CRUD.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogAlert
      v-model="abnormalExamineDialog"
      :title="$t('$vuetify.warning')"
      :message="
        $t('BusinessSetting.AccountOrderSettings.abnormal_examine_hint')
      "
      persistent
    />
    <DialogAlert
      v-model="productDateSettingDialog"
      :title="$t('$vuetify.warning')"
      :message="
        $t(
          'BusinessSetting.MaterialManagementSetting.productDateSettingWarningMsg'
        )
      "
      @cancel="
        productDateSetting ? (settingValues.product_date_setting = 1) : ''
      "
      useConfirm
      persistent
    />
    <DialogAlert
      v-model="distributionDistrictUniqueEnableDialog"
      :title="$t('$vuetify.warning')"
      :message="
        $t(
          'BusinessSetting.StockManagementSetting.deliveryAreaUniqueWarningMsg'
        )
      "
      persistent
    />

    <v-dialog v-model="editTaxDialog" scrollable width="600px">
      <v-card>
        <v-card-title class="mx-3">
          {{
            $t(
              "BusinessSetting.ResourcePaymentReceiptSetting.taxInfoFields.title"
            )
          }}
          <v-spacer />
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="editTaxDialog = false">
                fa-times
              </v-icon>
            </template>
            <span>{{ $t("$vuetify.close") }}</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text class="my-3">
          <v-row align="center">
            <v-col cols="3" class="font-weight-bold text-left">
              {{
                $t(
                  "BusinessSetting.ResourcePaymentReceiptSetting.taxInfoFields.tax"
                ) + $t("Global.colon")
              }}
            </v-col>
            <v-col cols="9" md="7">
              <v-text-field
                v-model="currentTax.tax"
                dense
                single-line
                suffix="%"
                type="number"
                style="max-width: 150px"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            class="elevation-1"
            @click="editTaxDialog = false"
          >
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" @click="saveTaxInfo('edit')">
            {{ $t("CRUD.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogAlert
      v-model="delTaxDialog"
      :title="$t('$vuetify.warning')"
      :message="
        $t(
          'BusinessSetting.ResourcePaymentReceiptSetting.taxSaveMsg.confirm_delete'
        )
      "
      useConfirm
      @confirm="saveTaxInfo('del')"
      persistent
    />
    <SupplierMaterialDialogAlert
      v-model="supplierMaterialDialog"
      :message="$t('BusinessSetting.supplierMaterialHint')"
    />
    <StocksSelectsDialog
      v-model="autoOutStocksDialog"
      :stockIds="autoOutStockIds"
      :types="[0]"
      :status="[1]"
      notWMS
      @confirm="choosedStocks = $event"
    />
  </div>
</template>
<style>
.row-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.ini_number_input_wrapper {
  width: 100%;
}

.ini_number_input_box {
  width: 11px;
  margin-right: 12px;
}

/* .block {
  width: 500px;
  background-color: #65b4ae;
  white-space: nowrap;
  overflow: hidden;
}
.words {
  position: relative;
  width: fit-content;
  animation: move 4s linear infinite;
  padding-left: 50px;
}
.words::after {
  position: absolute;
  right: -100%;
  content: attr(text);
}

@keyframes move {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  } */
/* } */
</style>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SearcherDistrict from "@/components/plugins/SearcherDistrict";
import SearcherTemplate from "@/components/plugins/SearcherTemplate";
import SearcherSupplier from "@/components/plugins/SearcherSupplier";
import DialogAlert from "@/components/plugins/DialogAlert";
import Settings from "@/api/settings";
import Districts from "@/api/districts";
import Templates from "@/api/templates";
import OrderCycles from "@/api/order_cycles";
import Files from "@/api/files";
import SupplierMaterials from "@/api/supplier_materials";
import SupplierMaterialDialogAlert from "./plugins/SupplierMaterialDialogAlert";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import Roles from "@/api/roles";
import StocksSelectsDialog from "@/components/plugins/StocksSelectsDialog.vue";
import Stocks from "@/api/stocks";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDistrict,
    SearcherTemplate,
    SearcherSupplier,
    DialogAlert,
    ValidationObserver,
    ValidationProvider,
    SupplierMaterialDialogAlert,
    SearcherDatetime,
    StocksSelectsDialog,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("SettingNav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.settings"),
        disabled: false,
        href: "/settings/bussiness-settings",
      },
      {
        text: i18n.t("SettingNav.businessSetting"),
        disabled: true,
        href: "/settings/bussiness-settings",
      },
    ],
    ShopBillArr() {
      var arr = [
        {
          type: "19",
          text: i18n.t(
            "BusinessSetting.ResourcePaymentReceiptSetting.shopBillFields.order"
          ),
        },
        {
          type: "4",
          text: i18n.t(
            "BusinessSetting.ResourcePaymentReceiptSetting.shopBillFields.stock_out_order"
          ),
        },
      ];
      if (
        this.financeBillEnable &&
        this.settings &&
        !this.settings.sub_account_enable
      ) {
        arr.push({
          type: "12",
          text: i18n.t(
            "BusinessSetting.ResourcePaymentReceiptSetting.shopBillFields.finance_bill"
          ),
        });
      }

      arr.push({
        type: "20",
        text: i18n.t(
          "BusinessSetting.ResourcePaymentReceiptSetting.shopBillFields.shop_examine"
        ),
      });
      return arr;
    },
    ReturnBillArr() {
      let arr = [
        {
          type: "3",
          text: i18n.t(
            "BusinessSetting.ResourcePaymentReceiptSetting.returnBillFields.return_order_in"
          ),
        },
        {
          type: "12",
          text: i18n.t(
            "BusinessSetting.ResourcePaymentReceiptSetting.returnBillFields.finance_bill"
          ),
        },
      ];
      return arr;
    },
    SupplierBillArr() {
      var arr = [
        {
          type: "3",
          text: i18n.t(
            "BusinessSetting.ResourcePaymentReceiptSetting.supplierBillFields.inTypeSupplier"
          ),
        },
      ];
      if (this.financeBillEnable) {
        arr.push({
          type: "12",
          text: i18n.t(
            "BusinessSetting.ResourcePaymentReceiptSetting.supplierBillFields.finance_bill"
          ),
        });
      }
      return arr;
    },
    PurchaseReturnBillArr() {
      let arr = [
        {
          type: "4",
          text: i18n.t(
            "BusinessSetting.ResourcePaymentReceiptSetting.purchaseReturnBillFields.return_order_out"
          ),
        },
        {
          type: "12",
          text: i18n.t(
            "BusinessSetting.ResourcePaymentReceiptSetting.purchaseReturnBillFields.finance_bill"
          ),
        },
      ];
      return arr;
    },
    PurchaseReturnOnlyBillArr() {
      let arr = [
        {
          type: "21",
          text: i18n.t(
              "BusinessSetting.ResourcePaymentReceiptSetting.purchaseReturnBillFields.return_order_out"
          ),
        },
        {
          type: "12",
          text: i18n.t(
              "BusinessSetting.ResourcePaymentReceiptSetting.purchaseReturnBillFields.finance_bill"
          ),
        },
      ];
      return arr;
    },
    // templatesItems() {
    //   return this.templates.map((template) => {
    //     const disabled = this.disabledItems
    //       ? this.disabledItems.find(
    //           (disabledItem) => disabledItem.id == template.id
    //         )
    //       : false;
    //     return Object.assign({}, template, { disabled });
    //   });
    // },
    templateConfigurationHeader() {
      return [
        {
          text: i18n.t(
            "BusinessSetting.AppAndWxApp.shopRegister.district_name"
          ),
          align: "center",
          sortable: false,
          filterable: true,
          value: "name",
        },
        {
          text: i18n.t(
            "BusinessSetting.AppAndWxApp.shopRegister.template_name"
          ),
          align: "start",
          sortable: false,
          filterable: true,
          value: "template_select",
        },
      ];
    },
    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    taxHeaders() {
      return [
        {
          text: i18n.t(
            "BusinessSetting.ResourcePaymentReceiptSetting.taxInfoFields.tax"
          ),
          align: "start",
          sortable: false,
          value: "tax",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    autoOutTime() {
      let arr = []
      let i = 0;
      for(i = 0; i < 24; i++) {
        arr.push({
          key:  ((i < 10) ? ('0' + i) : i) + ":00",
          value: ((i < 10) ? ('0' + i) : i) + ":00",
        })
      }
      return arr;
    },
    stockHeaders: () => [
      {
        text: i18n.t("Stock.Fields.stock_code"),
        align: "start",
        sortable: false,
        value: "code",
      },
      {
        text: i18n.t("Stock.Fields.stock_name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "end",
        sortable: false,
        value: "actions",
      }
    ],
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountInfo"]),
  },

  data: () => {
    return ({
      panels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      disabled: false,
      activeInput: 0,
      iniNumberLengthItem: [
        {
          key: "1",
          value: 1,
        },
        {
          key: "2",
          value: 2,
        },
        {
          key: "3",
          value: 3,
        },
        {
          key: "4",
          value: 4,
        },
        {
          key: "5",
          value: 5,
        },
        {
          key: "6",
          value: 6,
        },
        {
          key: "7",
          value: 7,
        },
        {
          key: "8",
          value: 8,
        },
        {
          key: "9",
          value: 9,
        },
      ],
      iniNumberLengthValue: 5,
      iniNumber: [
        {num: ""},
        {num: ""},
        {num: ""},
        {num: ""},
        {num: ""},
      ],
      timeQuantumSelect: [
        {
          key: "00:00-1:00",
          value: "00:00-1:00",
        },
        {
          key: "1:00-2:00",
          value: "1:00-2:00",
        },
        {
          key: "2:00-3:00",
          value: "2:00-3:00",
        },
        {
          key: "3:00-4:00",
          value: "3:00-4:00",
        },
        {
          key: "4:00-5:00",
          value: "4:00-5:00",
        },
        {
          key: "5:00-6:00",
          value: "5:00-6:00",
        },
        {
          key: "6:00-7:00",
          value: "6:00-7:00",
        },
        {
          key: "7:00-8:00",
          value: "7:00-8:00",
        },
        {
          key: "8:00-9:00",
          value: "8:00-9:00",
        },
        {
          key: "9:00-10:00",
          value: "9:00-10:00",
        },
        {
          key: "10:00-11:00",
          value: "10:00-11:00",
        },
        {
          key: "11:00-12:00",
          value: "11:00-12:00",
        },
        {
          key: "12:00-13:00",
          value: "12:00-13:00",
        },
        {
          key: "13:00-14:00",
          value: "13:00-14:00",
        },
        {
          key: "14:00-15:00",
          value: "14:00-15:00",
        },
        {
          key: "15:00-16:00",
          value: "15:00-16:00",
        },
        {
          key: "16:00-17:00",
          value: "16:00-17:00",
        },
        {
          key: "17:00-18:00",
          value: "17:00-18:00",
        },
        {
          key: "18:00-19:00",
          value: "18:00-19:00",
        },
        {
          key: "19:00-20:00",
          value: "19:00-20:00",
        },
        {
          key: "20:00-21:00",
          value: "20:00-21:00",
        },
        {
          key: "21:00-22:00",
          value: "21:00-22:00",
        },
        {
          key: "22:00-23:00",
          value: "22:00-23:00",
        },
        {
          key: "23:00-24:00",
          value: "23:00-24:00",
        },
      ],
      // autoOutTime: [
      //   {
      //     key: "00:00",
      //     value: "00:00",
      //   },
      //   {
      //     key: "01:00",
      //     value: "01:00",
      //   },
      //   {
      //     key: "02:00",
      //     value: "02:00",
      //   },
      //   {
      //     key: "03:00",
      //     value: "03:00",
      //   },
      //   {
      //     key: "04:00",
      //     value: "04:00",
      //   },
      //   {
      //     key: '05:00',
      //     value: "05:00",
      //   },
      //   {
      //     key: "06:00",
      //     value: "06:00",
      //   },
      //   {
      //     key: "07:00",
      //     value: "07:00",
      //   },
      //   {
      //     key: "08:00",
      //     value: "08:00",
      //   },
      //   {
      //     key: "09:00",
      //     value: "09:00",
      //   },
      //   {
      //     key: "10:00",
      //     value: "10:00",
      //   },{
      //     key: "11:00",
      //     value: "11:00",
      //   },
      //   {
      //     key: "12:00",
      //     value: "12:00",
      //   },
      //   {
      //     key: "13:00",
      //     value: "13:00",
      //   },
      //   {
      //     key: "14:00",
      //     value: "14:00",
      //   },
      //   {
      //     key: "04:00",
      //     value: "04:00",
      //   },
      //   {
      //     key: '05:00',
      //     value: "05:00",
      //   },
      //   {
      //     key: "06:00",
      //     value: "06:00",
      //   },
      //   {
      //     key: "07:00",
      //     value: "07:00",
      //   },
      //   {
      //     key: "08:00",
      //     value: "08:00",
      //   },
      //   {
      //     key: "09:00",
      //     value: "09:00",
      //   },
      //   {
      //     key: "10:00",
      //     value: "10:00",
      //   },
      // ],
      settingKeys: {
        keys: [
          "complex_password",
          "expired_password",
          "password_expiry_date",
          "app_loading_page",
          "app_title_logo",
          "customer_server_tel",
          "shop_register",
          "base_news_display",
          "shop_custom_name",
          "agent_custom_name",
          "remind_setting",
          "upload_setting",
          "ext_code_display",
          "order_method",
          "use_ordercycle",
          "base_close_ordercycle",
          "ordercycle",
          "order_start",
          "order_end",
          "distribution_print_and_distribute",
          "auto_examine",
          "abnormal_examine",
          "auto_examine_days",
          "examine_auto_return",
          "shop_examine_must_img",
          "invoice_type",
          "invoice_type_normal_percent",
          "invoice_type_value_added_percent",
          "app_price_alert_min",
          "app_price_alert_max",
          "auto_price_type",
          "order_memo_display",
          // "order_price_node",
          "sorting_out_lower_percent",
          "stock_position_setting",
          "batch_stock_out_type",
          "material_name_display_type",
          "material_auto_code",
          "material_image",
          "product_date_setting",
          "expired_batch_pick_setting",
          "material_force_bestbefore",
          "nearday",
          "bestbefore_default_days",
          "last_purchase_price",
          "order_detail_memo",
          "show_price_to_shop",
          "material_group_enable",
          "material_for_supplier",
          "distribution_district_unique",
          "distribution_district_unique_enable",
          "distribution_district_auto_add",
          "stock_history_create_time",
          "auto_cancel_order_time",
          "auto_cancel_time_type",
          "distribution_user_enable",
          "intelligent_purchase",
          "finance_bill_enable",
          "purchase_examine_percent",
          "receipt_show_category_enable",
          "use-tax",
          "tax_setting",
          "bill_credential_type",
          "cancel_auto_refund",
          "bill_express_fee_actual",
          "paid_close_order_fee",
          "auto_refund_to_balance",
          "purchase_price_valuation",
          "shop_psi_max_num",
          "cloud_print_enable",
          "stock_take_out_from_batch",
          "production_in_price_setting",
          "delivery_point",
          "sms_remain_notice",
          "qualify_report_enable",
          "show_purchase_address",
          "out_qualify_report_enable",
          "shop_balance_snapshot_time",
          "stock_order_express_edit_enable",
          "finance_bill_examine_enable",
          "examine_order_express_edit_enable",
          "pay_first_wait_pay_no_order",
          "order_method_without_admin",
          "other_in_price_setting",
          "other_out_price_setting",
          "return_out_price_setting",
          "requisition_express_price",
          // "shop_address_edit",
          "purchase_subtotal",
          "supplier_self_purchase",
          "template_edit_material_enable",
          "material_ext_code_enable",
          "auto_ruler_material_shelve_check",
          "out_add_check_negative",
          "no_pay_first_auto_confirm",
          "auto_out_setting",
          "requisition_in_no_modify",
          "requisition_express_display",
          "cash_discount",
          "bill_analyze_history_auto_add",
          "order_index_express_display",
        ],
      },
      settingValues: {},
      imgRules: [
        (value) => !value || value.size < 5000000 || i18n.t("Material.imgHint"),
      ],
      APP_loading_image: "",
      APP_loading_image_file: null,
      APP_log_image: "",
      APP_log_image_file: null,
      shop_register: {auto_make: "0", district_info: null, template_info: null},
      ext_code_display: {
        order: i18n.t(
            "BusinessSetting.BackstageSettings.order_ext_code_default_display"
        ),
        return_order: i18n.t(
            "BusinessSetting.BackstageSettings.return_order_ext_code_default_display"
        ),
        purchase: i18n.t(
            "BusinessSetting.BackstageSettings.purchase_ext_code_default_display"
        ),
        stock_out_order: i18n.t(
            "BusinessSetting.BackstageSettings.stockOut_order_ext_code_default_display"
        ),
        stock_in_order: i18n.t(
            "BusinessSetting.BackstageSettings.stockIn_order_ext_code_default_display"
        ),
      },
      order_start: "00:00",
      order_end: "23:59",

      abnormalExamine: 0,
      invoiceTypeNormal: false,
      invoiceTypeValueAdded: false,
      materialAutoCodeSetting: {
        auto_code: "1",
        follow_category: "0",
        fixed_prefix: "",
        ini_number: "",
      },
      intelligentPurchase: {},
      financeBillEnable: 0,
      billCredentialType: {
        order_edit: "0",
        examine_auto_in: "0",
        shop_bill: "4",
        return_bill: "3",
        purchase_bill: "3",
        purchase_return_bill: "4",
        purchase_return_only_bill: "21"
      },
      autoRefundToBalance: {
        is_enable: 0,
        order_status: 1,
      },
      districts: [],
      districtTree: [],
      districtsOpen: [],
      templateConfigurationDialog: false,
      templateConfigurationDialogLoading: false,
      itemsPerPageOptions: 10,
      templates: [],
      templatesLoading: false,
      templatesSearch: "",
      templatesSelected: null,
      orderCycles: [],
      abnormalExamineDialog: false,
      productDateSetting: 0,
      productDateSettingDialog: false,
      distributionDistrictUniqueEnableDialog: false,
      taxList: [],
      taxTabledisplay: false,
      editTaxDialog: false,
      delTaxDialog: false,
      supplierMaterialDialog: false,
      currentTax: {},
      district_template: {},
      material_for_supplier: null,
      auto_cancel_order_period: "",
      auto_cancel_order_clock: "",
      businessPermission: [],
      autoOutSetting: {
        auto_out: 0,
        in_type: 1,
        in_type_price: 0,
        out_time: null,
        stock_ids: [],
        types: [],
        date_type: null,
        date_day: null
      },
      autoOutTypeOrder: 0,
      autoOutTypeRequisition: 0,
      autoOutStocksDialog: false,
      autoOutSettingEditFlg: false,
      autoOutStocks: [],
      autoOutStockIds: [],
      choosedStocks: [], //每次选中的仓库
    });
  },

  mounted() {
    this.getPermissionFromAPI();
    this.getSettings();
    this.getTemplatesFromAPI();
  },

  methods: {
    getPermissionFromAPI() {
      // 获取权限
      Roles.getBusinessPermission().then(
          function (response) {
            if (response.data.status.isOK()) {
              this.businessPermission = response.data.business_permission
            }
          }.bind(this)
      );
    },
    getSettings() {
      //获取设置
      Settings.bussinessSetting(this.settingKeys).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settingValues = response.data.settings;
            this.settingValues = Object.assign({}, this.settingValues, {
              use_tax: this.settingValues["use-tax"],
            });
            this.financeBillEnable = this.settingValues.finance_bill_enable;

            //给没有值的设置项字段赋默认值
            if (
              this.settingValues.complex_password == null ||
              typeof this.settingValues.complex_password == "undefined" ||
              this.settingValues.complex_password == undefined
            ) {
              //复杂密码
              this.settingValues.complex_password = 0;
            }
            if (
              this.settingValues.expired_password == null ||
              typeof this.settingValues.expired_password == "undefined" ||
              this.settingValues.expired_password == undefined
            ) {
              //密码过期
              this.settingValues.expired_password = 0;
            }
            if (
              this.settingValues.shop_register.auto_make == null ||
              typeof this.settingValues.shop_register.auto_make ==
                "undefined" ||
              this.settingValues.shop_register.auto_make == undefined
            ) {
              //自动申请注册
              this.settingValues.shop_register.auto_make = "0";
            }
            if (
              this.settingValues.shop_register.template_setting == null ||
              typeof this.settingValues.shop_register.template_setting ==
                "undefined" ||
              this.settingValues.shop_register.template_setting == undefined
            ) {
              //自动申请注册模板设置
              this.settingValues.shop_register.template_setting = "1";
            }
            if (
              this.settingValues.shop_register.template_setting == null ||
              typeof this.settingValues.shop_register.template_setting ==
                "undefined" ||
              this.settingValues.shop_register.template_setting == undefined ||
              (this.settingValues.shop_register.district_info &&
                !Object.keys(this.settingValues.shop_register.district_info)
                  .length)
            ) {
              //默认分组
              this.settingValues.shop_register.district_info = null;
            }
            if (
              this.settingValues.shop_custom_name == null ||
              typeof this.settingValues.shop_custom_name == "undefined" ||
              this.settingValues.shop_custom_name == undefined
            ) {
              //要货终端名称
              this.settingValues.shop_custom_name = "客户";
            }
            if (
              this.settingValues.agent_custom_name == null ||
              typeof this.settingValues.agent_custom_name == "undefined" ||
              this.settingValues.agent_custom_name == undefined
            ) {
              //销售端名称
              this.settingValues.agent_custom_name = "销售";
            }

            if (
              this.settingValues.base_news_display == null ||
              typeof this.settingValues.base_news_display == "undefined" ||
              this.settingValues.base_news_display == undefined
            ) {
              //总品牌端发现内容推广
              this.settingValues.base_news_display = 1;
            }
            if (
              this.settingValues.order_method == null ||
              typeof this.settingValues.order_method == "undefined" ||
              this.settingValues.order_method == undefined
            ) {
              //要货端下单方式设置
              this.settingValues.order_method = 2;
            }
            if (
              this.settingValues.use_ordercycle == null ||
              typeof this.settingValues.use_ordercycle == "undefined" ||
              this.settingValues.use_ordercycle == undefined
            ) {
              //下单周期模式
              this.settingValues.use_ordercycle = 0;
            }
            if (
              this.settingValues.base_close_ordercycle == null ||
              typeof this.settingValues.base_close_ordercycle == "undefined" ||
              this.settingValues.base_close_ordercycle == undefined
            ) {
              //下单周期是否排除总部下单
              this.settingValues.base_close_ordercycle = 0;
            }
            if (
              this.settingValues.distribution_print_and_distribute == null ||
              typeof this.settingValues.distribution_print_and_distribute ==
                "undefined" ||
              this.settingValues.distribution_print_and_distribute == undefined
            ) {
              //配送单打印/批量配送打印启用自动配送设置
              this.settingValues.distribution_print_and_distribute = 0;
            }
            if (
              this.settingValues.abnormal_examine == null ||
              typeof this.settingValues.abnormal_examine == "undefined" ||
              this.settingValues.abnormal_examine == undefined
            ) {
              //启用验货异常处理设置
              this.settingValues.abnormal_examine = 0;
            }
            if (
              this.settingValues.auto_price_type == null ||
              typeof this.settingValues.auto_price_type == "undefined" ||
              this.settingValues.auto_price_type == undefined
            ) {
              //标配价格
              this.settingValues.auto_price_type = 0;
            }
            if (
              this.settingValues.order_memo_display == null ||
              typeof this.settingValues.order_memo_display == "undefined" ||
              this.settingValues.order_memo_display == undefined
            ) {
              //要货一览备注显示
              this.settingValues.order_memo_display = 1;
            }
            // if (
            //   this.settingValues.order_price_node == null ||
            //   typeof this.settingValues.order_price_node == "undefined" ||
            //   this.settingValues.order_price_node == undefined
            // ) {
            //   //要货单定价节点
            //   this.settingValues.order_price_node = 1;
            // }
            if (
              this.settingValues.sorting_out_lower_percent == null ||
              typeof this.settingValues.sorting_out_lower_percent ==
                "undefined" ||
              this.settingValues.sorting_out_lower_percent == undefined
            ) {
              //分拣出库下限预警
              this.settingValues.sorting_out_lower_percent = 0;
            }
            if (
              this.settingValues.no_pay_first_auto_confirm == null ||
              typeof this.settingValues.no_pay_first_auto_confirm ==
                "undefined" ||
              this.settingValues.no_pay_first_auto_confirm == undefined
            ) {
              // 非先款后货自动确认订单(按时间间隔执行)
              this.settingValues.no_pay_first_auto_confirm = null;
            }
            if (
              this.settingValues.order_index_express_display == null ||
              typeof this.settingValues.order_index_express_display == "undefined" ||
              this.settingValues.order_index_express_display == undefined
            ) {
              this.settingValues.order_index_express_display = 0
            }
            if (
              this.settingValues.batch_stock_out_type == null ||
              typeof this.settingValues.batch_stock_out_type == "undefined" ||
              this.settingValues.batch_stock_out_type == undefined
            ) {
              //批量出库单出库设置
              this.settingValues.batch_stock_out_type = 1;
            }
            if (
              this.settingValues.material_name_display_type == null ||
              typeof this.settingValues.material_name_display_type ==
                "undefined" ||
              this.settingValues.material_name_display_type == undefined
            ) {
              //商品名称显示类型
              this.settingValues.material_name_display_type = 2;
            }
            if (
              this.settingValues.product_date_setting == null ||
              typeof this.settingValues.product_date_setting == "undefined" ||
              this.settingValues.product_date_setting == undefined
            ) {
              //商品生产及过期日期
              this.settingValues.product_date_setting = 0;
            }
            if (
              this.settingValues.expired_batch_pick_setting == null ||
              typeof this.settingValues.expired_batch_pick_setting ==
                "undefined" ||
              this.settingValues.expired_batch_pick_setting == undefined
            ) {
              //过期批次不可拣货
              this.settingValues.expired_batch_pick_setting = 0;
            }
            if (
              this.settingValues.material_force_bestbefore == null ||
              typeof this.settingValues.material_force_bestbefore ==
                "undefined" ||
              this.settingValues.material_force_bestbefore == undefined
            ) {
              //启用商品强制保质期
              this.settingValues.material_force_bestbefore = 0;
            }
            if (
              this.settingValues.nearday == null ||
              typeof this.settingValues.nearday == "undefined" ||
              this.settingValues.nearday == undefined
            ) {
              //启用商品强制临期提醒
              this.settingValues.nearday = 0;
            }
            if (
              this.settingValues.last_purchase_price == null ||
              typeof this.settingValues.last_purchase_price == "undefined" ||
              this.settingValues.last_purchase_price == undefined
            ) {
              //是否启用上次采购入库单价
              this.settingValues.last_purchase_price = 0;
            }
            if (
              this.settingValues.order_detail_memo == null ||
              typeof this.settingValues.order_detail_memo == "undefined" ||
              this.settingValues.order_detail_memo == undefined
            ) {
              //是否启用商品单品备注
              this.settingValues.order_detail_memo = 0;
            }
            if (
              this.settingValues.show_price_to_shop == null ||
              typeof this.settingValues.show_price_to_shop == "undefined" ||
              this.settingValues.show_price_to_shop == undefined
            ) {
              //是否对订货端显示价格
              this.settingValues.show_price_to_shop = 1;
            }
            if (
              this.settingValues.material_group_enable == null ||
              typeof this.settingValues.material_group_enable == "undefined" ||
              this.settingValues.material_group_enable == undefined
            ) {
              //是否启用商品关联集
              this.settingValues.material_group_enable = 0;
            }
            if (
              this.settingValues.material_for_supplier == null ||
              typeof this.settingValues.material_for_supplier == "undefined" ||
              this.settingValues.material_for_supplier == undefined
            ) {
              //启用供应商托管
              this.material_for_supplier = 0;
              this.settingValues.material_for_supplier = 0;
            } else {
              this.material_for_supplier =
                this.settingValues.material_for_supplier;
            }
            if (
              this.settingValues.distribution_user_enable == null ||
              typeof this.settingValues.distribution_user_enable ==
                "undefined" ||
              this.settingValues.distribution_user_enable == undefined
            ) {
              //启用配送线路排序
              this.settingValues.distribution_user_enable = 0;
            }
            if (
              this.settingValues.finance_bill_enable == null ||
              typeof this.settingValues.finance_bill_enable == "undefined" ||
              this.settingValues.finance_bill_enable == undefined
            ) {
              //启用财务对账单
              this.financeBillEnable = 0;
            }
            if (
              this.settingValues.receipt_show_category_enable == null ||
              typeof this.settingValues.receipt_show_category_enable ==
                "undefined" ||
              this.settingValues.receipt_show_category_enable == undefined
            ) {
              //批量对账单详情导出启用一级分类显示
              this.settingValues.receipt_show_category_enable = 0;
            }
            if (
              this.settingValues.use_tax == null ||
              typeof this.settingValues.use_tax == "undefined" ||
              this.settingValues.use_tax == undefined
            ) {
              //启用价税分离
              this.settingValues.use_tax = 0;
            }
            if (
              this.settingValues.cancel_auto_refund == null ||
              typeof this.settingValues.cancel_auto_refund == "undefined" ||
              this.settingValues.cancel_auto_refund == undefined
            ) {
              //启用订单作废欠款原路退回
              this.settingValues.cancel_auto_refund = 0;
            }
            if (
              this.settingValues.bill_express_fee_actual == null ||
              typeof this.settingValues.bill_express_fee_actual ==
                "undefined" ||
              this.settingValues.bill_express_fee_actual == undefined
            ) {
              //账单响应实际运费
              this.settingValues.bill_express_fee_actual = 0;
            }
            if (
              this.settingValues.paid_close_order_fee == null ||
              typeof this.settingValues.paid_close_order_fee == "undefined" ||
              this.settingValues.paid_close_order_fee == undefined
            ) {
              //账单响应实际运费
              this.settingValues.paid_close_order_fee = 0;
            }
            if (
              this.settingValues.purchase_price_valuation == null ||
              typeof this.settingValues.purchase_price_valuation ==
                "undefined" ||
              this.settingValues.purchase_price_valuation == undefined
            ) {
              //是否显示最新采购价估值
              this.settingValues.purchase_price_valuation = 0;
            }
            if (
              this.settingValues.examine_auto_return == null ||
              typeof this.settingValues.examine_auto_return == "undefined" ||
              this.settingValues.examine_auto_return == undefined
            ) {
              // 验收差异生成退货单默认不启动
              this.settingValues.examine_auto_return = 0;
            }
            if (
              this.settingValues.shop_examine_must_img == null ||
              typeof this.settingValues.shop_examine_must_img == "undefined" ||
              this.settingValues.shop_examine_must_img == undefined
            ) {
              // 门店验收必须上传附件默认不启动
              this.settingValues.shop_examine_must_img = 0;
            }
            if (
              this.settingValues.auto_examine == null ||
              typeof this.settingValues.auto_examine == "undefined" ||
              this.settingValues.auto_examine == undefined
            ) {
              // 启用自动验货设置默认不启动
              this.settingValues.auto_examine = 0;
            }
            if (
              this.settingValues.cloud_print_enable == null ||
              typeof this.settingValues.cloud_print_enable == "undefined" ||
              this.settingValues.cloud_print_enable == undefined
            ) {
              // 是否启用云打印默认不启用
              this.settingValues.cloud_print_enable = 0;
            }
            if (
              this.settingValues.stock_take_out_from_batch == null ||
              typeof this.settingValues.stock_take_out_from_batch ==
                "undefined" ||
              this.settingValues.stock_take_out_from_batch == undefined
            ) {
              // 普通盘亏出库可选择批次
              this.settingValues.stock_take_out_from_batch = 0;
            }
            if (
              this.settingValues.template_edit_material_enable == null ||
              typeof this.settingValues.template_edit_material_enable ==
                "undefined" ||
              this.settingValues.template_edit_material_enable == undefined
            ) {
              // 启用模板导入同步商品
              this.settingValues.template_edit_material_enable = 0;
            }
            if (
              this.settingValues.material_ext_code_enable == null ||
              typeof this.settingValues.material_ext_code_enable ==
                "undefined" ||
              this.settingValues.material_ext_code_enable == undefined
            ) {
              // 启用商品第三方编号
              this.settingValues.material_ext_code_enable = 0;
            }
            if (
              this.settingValues.auto_ruler_material_shelve_check == null ||
              typeof this.settingValues.auto_ruler_material_shelve_check ==
                "undefined" ||
              this.settingValues.auto_ruler_material_shelve_check == undefined
            ) {
              this.settingValues.auto_ruler_material_shelve_check = 0;
            }
            if (
              this.settingValues.production_in_price_setting == null ||
              typeof this.settingValues.production_in_price_setting ==
                "undefined" ||
              this.settingValues.production_in_price_setting == undefined
            ) {
              // 入库价格填充设置
              this.settingValues.production_in_price_setting = 1;
            }
            if (
              this.settingValues.delivery_point == null ||
              typeof this.settingValues.delivery_point == "undefined" ||
              this.settingValues.delivery_point == undefined
            ) {
              this.settingValues.delivery_point = 0;
            }
            if (
              this.settingValues.sms_remain_notice == null ||
              typeof this.settingValues.sms_remain_notice == "undefined" ||
              this.settingValues.sms_remain_notice == undefined
            ) {
              // 是否启用短信数量不足提醒
              this.settingValues.sms_remain_notice = 0;
            }
            if (
              this.settingValues.qualify_report_enable == null ||
              typeof this.settingValues.qualify_report_enable == "undefined" ||
              this.settingValues.qualify_report_enable == undefined
            ) {
              // 是否启用质检报告
              this.settingValues.qualify_report_enable = 0;
            }
            if (
              this.settingValues.out_qualify_report_enable == null ||
              typeof this.settingValues.out_qualify_report_enable ==
                "undefined" ||
              this.settingValues.out_qualify_report_enable == undefined
            ) {
              // 出库单是否展示质检报告
              this.settingValues.out_qualify_report_enable = 0;
            }
            if (
              this.settingValues.show_purchase_address == null ||
              typeof this.settingValues.show_purchase_address == "undefined" ||
              this.settingValues.show_purchase_address == undefined
            ) {
              // 采购单是否显示地址
              this.settingValues.show_purchase_address = 0;
            }
            if (
              this.settingValues.purchase_subtotal == null ||
              typeof this.settingValues.purchase_subtotal == "undefined" ||
              this.settingValues.purchase_subtotal == undefined
            ) {
              // 是否启用采购小计
              this.settingValues.purchase_subtotal = 0;
            }
            if (
              this.settingValues.supplier_self_purchase == null ||
              typeof this.settingValues.supplier_self_purchase == "undefined" ||
              this.settingValues.supplier_self_purchase == undefined
            ) {
              // 是否开启供应商自主采购单
              this.settingValues.supplier_self_purchase = 0;
            }
            if (
              this.settingValues.stock_order_express_edit_enable == null ||
              typeof this.settingValues.stock_order_express_edit_enable ==
                "undefined" ||
              this.settingValues.stock_order_express_edit_enable == undefined
            ) {
              // 以出库值算运费
              this.settingValues.stock_order_express_edit_enable = 0;
            }
            if (
              this.settingValues.finance_bill_examine_enable == null ||
              typeof this.settingValues.finance_bill_examine_enable ==
                "undefined" ||
              this.settingValues.finance_bill_examine_enable == undefined
            ) {
              // 以验收值生成要货对账单
              this.settingValues.finance_bill_examine_enable = 0;
            }
            if (
              this.settingValues.examine_order_express_edit_enable == null ||
              typeof this.settingValues.examine_order_express_edit_enable ==
                "undefined" ||
              this.settingValues.examine_order_express_edit_enable == undefined
            ) {
              // 以验收值算运费
              this.settingValues.examine_order_express_edit_enable = 0;
            }
            if (
              this.settingValues.order_method_without_admin == null ||
              typeof this.settingValues.order_method_without_admin ==
                "undefined" ||
              this.settingValues.order_method_without_admin == undefined
            ) {
              // 一日一单是否排除总部下单
              this.settingValues.order_method_without_admin = 0;
            }
            if (
              this.settingValues.other_in_price_setting == null ||
              typeof this.settingValues.other_in_price_setting == "undefined" ||
              this.settingValues.other_in_price_setting == undefined
            ) {
              // 退货入库、其他入库价格设置
              this.settingValues.other_in_price_setting = 2;
            }
            if (
              this.settingValues.other_out_price_setting == null ||
              typeof this.settingValues.other_out_price_setting ==
                "undefined" ||
              this.settingValues.other_out_price_setting == undefined
            ) {
              // 报损出库、领料出库、其他出库、盘亏出库价格设置
              this.settingValues.other_out_price_setting = 2;
            }
            if (
              this.settingValues.return_out_price_setting == null ||
              typeof this.settingValues.return_out_price_setting ==
                "undefined" ||
              this.settingValues.return_out_price_setting == undefined
            ) {
              // 退货出库(上次采购价，退货出库选择供应商时，根据商品的上次采购入库价显示)
              this.settingValues.return_out_price_setting = 1;
            }
            if (
                this.settingValues.requisition_express_price == null ||
                typeof this.settingValues.requisition_express_price ==
                  "undefined" ||
                this.settingValues.requisition_express_price == undefined
            ) {
                // 是否启用调拨单运费
                this.settingValues.requisition_express_price = 0;
              }
            if (
              this.settingValues.requisition_in_no_modify == null ||
              typeof this.settingValues.requisition_in_no_modify == "undefined" ||
              this.settingValues.requisition_in_no_modify == undefined
            ) {
              // 调拨入库是否允许改价
              this.settingValues.requisition_in_no_modify = 0;
            }
            if (
              this.settingValues.requisition_express_display == null ||
              typeof this.settingValues.requisition_express_display == "undefined" ||
              this.settingValues.requisition_express_display == undefined
            ) {
              // 调拨一览是否显示调拨运费
              this.settingValues.requisition_express_display = 0;
            }
            if (
              this.settingValues.out_add_check_negative == null ||
              typeof this.settingValues.out_add_check_negative == "undefined" ||
              this.settingValues.out_add_check_negative == undefined
            ) {
              // 新增出库单校验负库存
              this.settingValues.out_add_check_negative = 0;
            }
            if (
              this.settingValues.cash_discount == null ||
              typeof this.settingValues.cash_discount == "undefined" ||
              this.settingValues.cash_discount == undefined
            )
            {
              // 是否启用现金折扣
              this.settingValues.cash_discount = 0;
            }
            if (
              this.settingValues.bill_analyze_history_auto_add == null ||
              typeof this.settingValues.bill_analyze_history_auto_add == "undefined" ||
              this.settingValues.bill_analyze_history_auto_add == undefined
            ) {
              // 应收应付统计历史自动生成
              this.settingValues.bill_analyze_history_auto_add = 0
            }
            // if (
            //   this.settingValues.shop_address_edit == null ||
            //   typeof this.settingValues.shop_address_edit == "undefined" ||
            //   this.settingValues.shop_address_edit == undefined
            // ) {
            //   // 门店端是否可修改门店地址
            //   this.settingValues.shop_address_edit = 0
            // }

            if (
              this.settingValues.tax_setting == null ||
              this.settingValues.tax_setting == "null" ||
              typeof this.settingValues.tax_setting == "undefined" ||
              this.settingValues.tax_setting == undefined
            ) {
              // 税率信息
              this.settingValues.tax_setting = [];
            }
            if (
              this.settingValues.pay_first_wait_pay_no_order == null ||
              this.settingValues.pay_first_wait_pay_no_order == "null" ||
              typeof this.settingValues.pay_first_wait_pay_no_order ==
                "undefined" ||
              this.settingValues.pay_first_wait_pay_no_order == undefined
            ) {
              // 先款后货未支付不可下单
              this.settingValues.pay_first_wait_pay_no_order = [];
            }
            if (this.settingValues.tax_setting) {
              for (let key in this.settingValues.tax_setting) {
                this.taxList.push({
                  id: key,
                  tax: this.settingValues.tax_setting[key],
                });
              }
            }
            if (this.settingValues.auto_cancel_order_time) {
              if (this.settingValues.auto_cancel_time_type == 2) {
                this.auto_cancel_order_clock =
                  this.settingValues.auto_cancel_order_time;
              } else {
                this.auto_cancel_order_period =
                  this.settingValues.auto_cancel_order_time;
              }
            }
            this.order_start = this.settingValues.order_start;
            this.order_end = this.settingValues.order_end;
            if (this.settingValues.auto_out_setting) {
              this.autoOutSetting = this.settingValues.auto_out_setting;
              if (this.autoOutSetting.stock_ids.length > 0) {
                this.autoOutStockIds = this.autoOutSetting.stock_ids
                this.getStocksFromApi()
              }
              if (this.autoOutSetting.date_type) {
                this.autoOutSetting.date_type = Number(this.autoOutSetting.date_type)
              }
              if (this.autoOutSetting.in_type) {
                this.autoOutSetting.in_type = Number(this.autoOutSetting.in_type)
              }
              this.autoOutTypeOrder = this.autoOutSetting.types.find((t) => t == 1) ? 1 : 0;
              this.autoOutTypeRequisition = this.autoOutSetting.types.find((t) => t == 2) ? 1 : 0;
            }
            this.district_template =
              this.settingValues.shop_register.district_template;
          }
        }.bind(this)
      );

      //获取下单周期列表
      OrderCycles.fetchAllForSelect().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.orderCycles = response.data.order_cycles;
          }
        }.bind(this)
      );
    },
    // 自动校准输入顺序
    adjust(index) {
      let dom = document.getElementById("initialize" + this.activeInput);
      //初始流水号的长度(通过接口获取到的字段的值)
      let iniNumSettingLen = 0;
      if (
        this.materialAutoCodeSetting &&
        this.materialAutoCodeSetting.ini_number
      )
        iniNumSettingLen = this.materialAutoCodeSetting.ini_number.length;
      //获取输入框已输入值的长度
      let inputNumLen = 0;
      this.iniNumber.map((d) => {
        if (d.num.length) {
          ++inputNumLen;
        }
      });
      //根据输入框已输入值的长度与初始流水号的长度(通过接口获取到的字段的值)对比判断聚焦在哪个input上
      if (inputNumLen == iniNumSettingLen || inputNumLen > iniNumSettingLen) {
        dom = document.getElementById("initialize" + (iniNumSettingLen - 1));
      } else if (
        inputNumLen > 0 &&
        inputNumLen < this.materialAutoCodeSetting.ini_number.length
      ) {
        dom = document.getElementById("initialize" + (inputNumLen - 1));
      } else if (inputNumLen == 0) {
        dom = document.getElementById("initialize0");
      }
      if (index != this.activeInput && dom) dom.focus();
    },
    // 控制输入前后方向
    inputDirection(index) {
      let val = this.iniNumber[index].num;
      // 回退键处理
      if (event.keyCode == 8 && val == "" && this.activeInput > 0) {
        // 重新校准
        let dom = document.getElementById("initialize" + (index - 1));
        this.activeInput = index - 1;
        if (dom) dom.focus();
      }
      //自动聚焦到下个输入框
      if (event.keyCode != 8 && val != "") {
        // 重新校准
        let dom = document.getElementById("initialize" + (index + 1));
        this.activeInput = index + 1;
        if (dom) dom.focus();
      }
    },
    // 输入框相互联动
    inputFinish(index) {
      if (this.iniNumber[index].num.length > 1) {
        this.$nextTick(() => {
          this.iniNumber[index].num = this.iniNumber[index].num.substr(0, 1);
        });
      }
    },
    // 清除图片
    clearImage(image_key) {
      var submitData = [
        {
          setting_key: image_key,
          setting_value: "",
        },
      ];
      this.$store.dispatch("fullscreenLoading");
      Settings.batchSave(submitData)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getSettings();
              //清除图片
              if (image_key == "app_loading_page") {
                !this.APP_loading_image.startsWith("data:image/") &&
                this.APP_loading_image == this.settingValues.app_loading_page
                  ? (this.settingValues.app_loading_page =
                      this.APP_loading_image =
                        null)
                  : (this.APP_loading_image = null);
              } else if (image_key == "app_title_logo") {
                !this.APP_log_image.startsWith("data:image/") &&
                this.APP_log_image == this.settingValues.app_title_logo
                  ? (this.settingValues.app_title_logo = this.APP_log_image =
                      null)
                  : (this.APP_log_image = null);
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    newDistricts(districts) {
      var district = districts.map((district) => {
        var templateSelected = null;
        if (district.districts.length) {
          for (let key in this.district_template) {
            if (district.code == key) {
              if (this.templates.length) {
                templateSelected = this.templates.find(
                  (template) => template.id == this.district_template[key]
                );
              }
            }
          }
          return Object.assign({}, district, {
            templateSelected: templateSelected,
            districts: this.newDistricts(district.districts),
          });
        } else {
          for (let key in this.district_template) {
            if (district.code == key) {
              if (this.templates.length) {
                templateSelected = this.templates.find(
                  (template) => template.id == this.district_template[key]
                );
              }
            }
          }
          return Object.assign({}, district, {
            templateSelected: templateSelected,
          });
        }
      });
      return district;
    },
    //获取分组列表
    getDistrictTree() {
      // this.$store.dispatch("fullscreenLoading");
      Districts.tree()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.districts = response.data.districts.map((district) => {
                var templateSelected = null;
                if (
                  this.district_template &&
                  Object.keys(this.district_template).length
                ) {
                  if (district.districts.length) {
                    for (let key in this.district_template) {
                      if (district.code == key) {
                        if (this.templates.length) {
                          templateSelected = this.templates.find(
                            (template) =>
                              template.id == this.district_template[key]
                          );
                        }
                        // delete this.district_template.key;
                      }
                    }
                    return Object.assign({}, district, {
                      templateSelected: templateSelected,
                      districts: this.newDistricts(district.districts),
                    });
                  } else {
                    for (let key in this.district_template) {
                      if (district.code == key) {
                        if (this.templates.length) {
                          templateSelected = this.templates.find(
                            (template) =>
                              template.id == this.district_template[key]
                          );
                        }
                      }
                    }
                    return Object.assign({}, district, {
                      templateSelected: templateSelected,
                    });
                  }
                }
              });
              this.openTree(this.districts);
              this.templateConfigurationDialog = true;
            }
            // this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            // this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    //获取要货模版
    getTemplatesFromAPI() {
      this.templatesLoading = true;
      Templates.fetch()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.templates = response.data.templates;
            }
            this.templatesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.templatesLoading = false;
          }.bind(this)
        );
    },
    //分组树形结构全展开
    openTree(openArr) {
      for (var i = 0; i < openArr.length; i++) {
        this.districtsOpen.push(openArr[i]);
        if (openArr[i].districts.length > 0) {
          this.openTree(openArr[i].districts);
        }
      }
      // if (validate) {
      //   this.$refs.templateConfigurationDialogObserver.validate();
      // }
    },
    //检查所有分组是否都绑定了要货模板
    checkDistrictsBind(districts) {
      districts.forEach((district) => {
        if (district.districts.length) {
          this.checkDistrictsBind(district.districts);
        } else {
          if (
            district.templateSelected &&
            Object.keys(district.templateSelected).length
          ) {
            return true;
          } else {
            return false;
          }
        }
      });
    },
    // 保存子分组和模板的绑定
    saveDistrictsBind(districts) {
      districts.forEach((district) => {
        var obj = {};
        obj[district.code] = district.templateSelected.id;
        this.district_template = Object.assign({}, this.district_template, obj);
        if (district.districts.length) {
          this.saveDistrictsBind(district.districts);
        }
      });
    },
    //保存分组和模板的绑定
    saveDistrictBindTemplates() {
      this.$refs.templateConfigurationDialogObserver.validate().then(
        async function (result) {
          if (result) {
            this.districts.forEach((district) => {
              var obj = {};
              obj[district.code] = district.templateSelected.id;
              this.district_template = Object.assign(
                {},
                this.district_template,
                obj
              );
              if (district.districts.length) {
                this.saveDistrictsBind(district.districts);
              }
            });

            this.openTree(this.districts);
            this.$nextTick(() => {
              this.$refs.templateConfigurationDialogObserver.validate();
            });
            this.templateConfigurationDialog = false;
          }
        }.bind(this)
      );
    },
    //启用配送范围唯一
    updateDistributionDistrictUnique() {
      if (!this.settingValues.distribution_district_unique_enable) {
        this.distributionDistrictUniqueEnableDialog = true;
        this.$nextTick(() => {
          this.settingValues.distribution_district_unique = 0;
        });
      }
    },
    //保存税率信息
    saveTaxInfo(mode) {
      let taxSettingCopy = JSON.parse(
        JSON.stringify(this.settingValues.tax_setting)
      );
      if (mode == "edit") {
        if (Object.keys(this.currentTax).length) {
          let isExist = this.taxList.some((list) => {
            if (list.tax == this.currentTax.tax) {
              return true;
            }
          });
          if (!isExist) {
            if (this.currentTax.id && this.currentTax.tax) {
              for (let key in taxSettingCopy) {
                if (key == this.currentTax.id) {
                  taxSettingCopy[key] = this.currentTax.tax;
                }
              }
            } else if (!this.currentTax.id && this.currentTax.tax) {
              let newTax = {};
              newTax[Object.keys(taxSettingCopy).length + 1] =
                this.currentTax.tax;
              taxSettingCopy = Object.assign({}, taxSettingCopy, newTax);
            }
            //保存更新税率信息
            Settings.batchSave([
              {
                setting_key: "tax_setting",
                setting_value: taxSettingCopy,
              },
            ]).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.editTaxDialog = false;
                  this.taxList = [];
                  this.getSettings();
                }
              }.bind(this)
            );
          } else {
            this.$snackbar.error(
              i18n.t(
                "BusinessSetting.ResourcePaymentReceiptSetting.taxSaveMsg.is_existed_msg"
              )
            );
          }
        } else {
          this.$snackbar.error(
            i18n.t(
              "BusinessSetting.ResourcePaymentReceiptSetting.taxSaveMsg.is_null_msg"
            )
          );
        }
      } else if (mode == "del") {
        let newTaxSetting = {};
        let new_tax_key = 0;
        for (let key in taxSettingCopy) {
          if (
            Number(key) < Number(this.currentTax.id) ||
            Number(key) > Number(this.currentTax.id)
          ) {
            new_tax_key++;
            newTaxSetting[new_tax_key] = taxSettingCopy[key];
          }
        }

        //保存更新税率信息
        Settings.batchSave([
          {
            setting_key: "tax_setting",
            setting_value: newTaxSetting,
          },
        ]).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.taxList = [];
              this.getSettings();
            }
          }.bind(this)
        );
      }
    },
    //保存设置
    async saveSettings() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            var submitItems = [];
            for (let key in this.settingValues) {
              if (key == "app_loading_page") {
                if (this.APP_loading_image_file) {
                  let response = await Files.imageUpload(
                    this.APP_loading_image_file,
                    false,
                    "images"
                  );
                  if (response.data.status.isOK()) {
                    submitItems.push({
                      setting_key: key,
                      setting_value: response.data.data.img_name,
                    });
                  }
                }
              } else if (key == "app_title_logo") {
                if (this.APP_log_image_file) {
                  let response = await Files.imageUpload(
                    this.APP_log_image_file,
                    false,
                    "images"
                  );
                  if (response.data.status.isOK()) {
                    submitItems.push({
                      setting_key: key,
                      setting_value: response.data.data.img_name,
                    });
                  }
                }
              } else if (key == "shop_register") {
                submitItems.push({
                  setting_key: key,
                  setting_value: Object.assign({}, this.shop_register, {
                    district_template: this.district_template,
                    template_id: this.shop_register.template_info.id
                  }),
                });
              } else if (key == "ext_code_display") {
                submitItems.push({
                  setting_key: key,
                  setting_value: this.ext_code_display,
                });
              } else if (key == "order_start") {
                submitItems.push({
                  setting_key: key,
                  setting_value: this.order_start,
                });
              } else if (key == "order_end") {
                submitItems.push({
                  setting_key: key,
                  setting_value: this.order_end,
                });
              } else if (key == "abnormal_examine") {
                submitItems.push({
                  setting_key: key,
                  setting_value: this.abnormalExamine,
                });
              } else if (key == "invoice_type") {
                let invoice_type = [];
                if (this.invoiceTypeNormal) {
                  invoice_type.push("1");
                }
                if (this.invoiceTypeValueAdded) {
                  invoice_type.push("2");
                }
                submitItems.push({
                  setting_key: key,
                  setting_value: invoice_type,
                });
              } else if (key == "material_auto_code") {
                let ini_number_str = "";
                this.iniNumber.forEach((d) => {
                  ini_number_str += d.num;
                });
                this.materialAutoCodeSetting = Object.assign(
                  {},
                  this.materialAutoCodeSetting,
                  {
                    ini_number: ini_number_str,
                  }
                );
                submitItems.push({
                  setting_key: key,
                  setting_value: this.materialAutoCodeSetting,
                });
              } else if (
                key == "intelligent_purchase" &&
                Object.keys(this.intelligentPurchase).length
              ) {
                submitItems.push({
                  setting_key: key,
                  setting_value: {
                    stock_limit: this.intelligentPurchase.stock_limit,
                    up_percent: this.intelligentPurchase.up_percent,
                    supplier_id: this.intelligentPurchase.supplier
                      ? this.intelligentPurchase.supplier.id
                      : "",
                  },
                });
              } else if (key == "bill_credential_type") {
                submitItems.push({
                  setting_key: key,
                  setting_value: this.billCredentialType,
                });
              } else if (key == "use-tax") {
                submitItems.push({
                  setting_key: key,
                  setting_value: this.settingValues.use_tax,
                });
                delete this.settingValues.use_tax;
              } else if (key == "auto_refund_to_balance") {
                submitItems.push({
                  setting_key: key,
                  setting_value: this.autoRefundToBalance,
                });
              } else if (key == "material_for_supplier") {
                submitItems.push({
                  setting_key: key,
                  setting_value: this.material_for_supplier,
                });
              } else if (key == "auto_cancel_order_time") {
                submitItems.push({
                  setting_key: key,
                  setting_value:
                    this.settingValues.auto_cancel_time_type == 2
                      ? this.auto_cancel_order_clock
                      : this.auto_cancel_order_period,
                });
              } else if (key == "auto_out_setting") {
                if (this.autoOutSetting.auto_out == 1) {
                  this.autoOutSetting.stock_ids = this.autoOutStockIds;
                  this.autoOutSetting.types = []
                  if (this.autoOutTypeOrder) {
                    this.autoOutSetting.types.push(1)
                  }
                  if (this.autoOutTypeRequisition) {
                    this.autoOutSetting.types.push(2)
                  }
                } else {
                  this.autoOutSetting = {
                    auto_out: 0,
                    in_type: 1,
                    in_type_price: 0,
                    out_time: null,
                    stock_ids: [],
                    types: [],
                    date_type: null,
                    date_day: null
                  }
                }
                submitItems.push({
                  setting_key: key,
                  setting_value:this.autoOutSetting
                })
              }  else {
                submitItems.push({
                  setting_key: key,
                  setting_value: this.settingValues[key],
                });
              }
            }

            Settings.batchSave(submitItems).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$snackbar.success(i18n.t("BusinessSetting.saveSuccess"));
                  this.getSettings();
                }
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
            this.$snackbar.error(i18n.t("BusinessSetting.saveError"));
          }
        }.bind(this)
      );
    },
    clearExpressSetting(data) {
      if (data == "shop_bill") {
        this.settingValues.stock_order_express_edit_enable = 0;
        this.settingValues.examine_order_express_edit_enable = 0;
      } else {
        if (this.settingValues[data]) {
          if (data == "bill_express_fee_actual") {
            this.settingValues.examine_order_express_edit_enable = 0;
          } else if (data == "examine_order_express_edit_enable") {
            this.settingValues.bill_express_fee_actual = 0;
          }
        }
      }
    },
    getStocksFromApi() {
      let fieldFilter = [
        "id",
        "code",
        "name",
        "type",
        "status",
        "StockDistrict.id"
      ];
      let options = Object.assign(
          {
            fieldFilter: fieldFilter,
            stock_ids: this.autoOutSetting.stock_ids.length > 0 ? this.autoOutSetting.stock_ids : [-1]
            // 仅筛选少许必要字段
          },
          this.options
      );
      Stocks.fetchAllNoPaging(options).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.autoOutStocks = response.data.stocks.map((stock) => {
                stock.choose = 1;
                return stock;
              });
            }
          }.bind(this)
      );
    },
  },

  watch: {
    settingValues: {
      deep: true,
      handler() {
        if (this.settingValues.app_loading_page)
          this.APP_loading_image = this.settingValues.app_loading_page;

        if (this.settingValues.app_title_logo)
          this.APP_log_image = this.settingValues.app_title_logo;

        if (this.settingValues.shop_register)
          this.shop_register = this.settingValues.shop_register;

        if (this.settingValues.ext_code_display)
          this.ext_code_display = this.settingValues.ext_code_display;

        this.abnormalExamine = this.settingValues.abnormal_examine;

        if (
          this.settingValues.invoice_type &&
          this.settingValues.invoice_type.indexOf("1") > -1
        )
          this.invoiceTypeNormal = true;
        if (
          this.settingValues.invoice_type &&
          this.settingValues.invoice_type.indexOf("2") > -1
        )
          this.invoiceTypeValueAdded = true;

        if (this.settingValues.material_auto_code)
          this.materialAutoCodeSetting = this.settingValues.material_auto_code;

        if (this.settingValues.product_date_setting)
          this.productDateSetting = this.settingValues.product_date_setting;
        if (this.settingValues.intelligent_purchase)
          this.intelligentPurchase = Object.assign(
            {},
            this.settingValues.intelligent_purchase,
            {
              supplier: {
                id: this.settingValues.intelligent_purchase.supplier_id,
              },
            }
          );
        if (this.settingValues.bill_credential_type) {
          this.billCredentialType = this.settingValues.bill_credential_type;
          if (
            this.billCredentialType.purchase_bill == null ||
            typeof this.billCredentialType.purchase_bill == "undefined" ||
            this.billCredentialType.purchase_bill == undefined
          ) {
            this.billCredentialType.purchase_bill = "3";
          }
          if (
            this.billCredentialType.return_bill == null ||
            typeof this.billCredentialType.return_bill == "undefined" ||
            this.billCredentialType.return_bill == undefined
          ) {
            this.billCredentialType.return_bill = "3";
          }
          if (
            this.billCredentialType.purchase_return_bill == null ||
            typeof this.billCredentialType.purchase_return_bill ==
              "undefined" ||
            this.billCredentialType.purchase_return_bill == undefined
          ) {
            this.billCredentialType.purchase_return_bill = "4";
          }
          if (
            this.billCredentialType.purchase_return_only_bill == null ||
            typeof this.billCredentialType.purchase_return_only_bill ==
              "undefined" ||
            this.billCredentialType.purchase_return_only_bill == undefined
          ) {
            this.billCredentialType.purchase_return_only_bill = "21";
          }
        }
        if (this.settingValues.auto_refund_to_balance)
          this.autoRefundToBalance = this.settingValues.auto_refund_to_balance;

        if (!this.settingValues.qualify_report_enable) {
          this.settingValues.out_qualify_report_enable =
            this.settingValues.qualify_report_enable;
        }
        if (!this.settingValues.requisition_express_price) {
          this.settingValues.requisition_express_display = 0;
        }
      },
    },
    material_for_supplier: {
      handler() {
        if (
          this.material_for_supplier &&
          this.settingValues.material_for_supplier == 0
        ) {
          SupplierMaterials.judgeOnlySupplierMaterial().then(
            function (response) {
              if (response.data.status.isOK()) {
                if (response.data.material && response.data.material.length) {
                  this.material_for_supplier = 0;
                  this.supplierMaterialDialog = true;
                }
              }
            }.bind(this)
          );
        } else if (this.settingValues.material_for_supplier == 1) {
          this.settingValues.material_for_supplier = 0;
        }
      },
    },
    APP_loading_image: {
      handler() {
        if (!this.APP_loading_image) {
          this.APP_loading_image_file = null;
        }
      },
    },
    APP_loading_image_file: {
      handler() {
        if (this.APP_loading_image_file) {
          var reader = new FileReader();
          reader.readAsDataURL(this.APP_loading_image_file);
          let that = this;
          reader.onload = function () {
            that.APP_loading_image = this.result;
          };
        } else {
          this.APP_loading_image = this.settingValues.app_loading_page;
        }
      },
    },
    APP_log_image: {
      handler() {
        if (!this.APP_log_image) {
          this.APP_log_image_file = null;
        }
      },
    },
    APP_log_image_file: {
      handler() {
        if (this.APP_log_image_file) {
          var reader = new FileReader();
          reader.readAsDataURL(this.APP_log_image_file);
          let that = this;
          reader.onload = function () {
            that.APP_log_image = this.result;
          };
        } else {
          this.APP_log_image = this.settingValues.app_title_logo;
        }
      },
    },
    shop_register: {
      handler() {
        if (
          this.shop_register.template_info &&
          !Object.keys(this.shop_register.template_info).length
        ) {
          this.shop_register.template_info = Object.assign(
            {},
            this.shop_register.template_info,
            { id: 0 }
          );
        }
      },
    },
    abnormalExamine: {
      handler() {
        if (!this.settingValues.abnormal_examine && this.abnormalExamine) {
          this.abnormalExamineDialog = true;
        }
      },
    },
    iniNumberLengthValue: {
      immediate: true,
      handler() {
        if (this.iniNumber.length != this.iniNumberLengthValue) {
          let newIniNumber = [];
          for (let i = 0; i < this.iniNumberLengthValue; i++) {
            newIniNumber.push({ num: "" });
          }
          this.iniNumber = newIniNumber;
        }
      },
    },
    materialAutoCodeSetting: {
      handler() {
        if (
          this.materialAutoCodeSetting &&
          this.materialAutoCodeSetting.ini_number
        ) {
          this.iniNumberLengthValue =
            this.materialAutoCodeSetting.ini_number.length;
          var number = "";
          var iniNumberArr = [];
          for (
            let i = 0;
            i < this.materialAutoCodeSetting.ini_number.length;
            i++
          ) {
            number = this.materialAutoCodeSetting.ini_number.substr(i, 1);
            iniNumberArr[i] = { num: number };
          }
          this.iniNumber = JSON.parse(JSON.stringify(iniNumberArr));
        }
      },
    },
    editTaxDialog: {
      handler() {
        if (!this.editTaxDialog) {
          this.currentTax = {};
        }
      },
    },
    templateConfigurationDialog: {
      handler() {
        if (!this.templateConfigurationDialog) {
          this.districts = [];
        }
      },
    },
    order_start: {
      handler() {
        if (
          this.order_start &&
          this.order_end &&
          this.order_start > this.order_end
        ) {
          this.$snackbar.error(
            i18n.t("BusinessSetting.AccountOrderSettings.timeCompareOne")
          );
        }
      },
    },
    order_end: {
      handler() {
        if (
          this.order_start &&
          this.order_end &&
          this.order_start > this.order_end
        ) {
          this.$snackbar.error(
            i18n.t("BusinessSetting.AccountOrderSettings.timeCompareTwo")
          );
        }
      },
    },
    financeBillEnable: {
      handler() {
        this.settingValues.finance_bill_enable = this.financeBillEnable;
        if (!this.financeBillEnable) {
          this.$set(this.billCredentialType, "order_edit", "0");
          this.$set(this.billCredentialType, "examine_auto_in", "0");
          this.$set(this.billCredentialType, "shop_bill", "4");
          this.$set(this.billCredentialType, "return_bill", "3");
          this.$set(this.billCredentialType, "purchase_bill", "3");
          this.$set(this.billCredentialType, "purchase_return_bill", "4");
          this.$set(this.billCredentialType, "purchase_return_only_bill", "21");
          this.clearExpressSetting("shop_bill");
        }
      },
    },
    // 监听单次选择的仓库
    choosedStocks: {
      handler() {
        //  综合多次选择的供应商
        this.choosedStocks.map((stock) => {
          this.autoOutStocks.push(stock)
        });
      },
    },
    autoOutStocks: {
      deep: true,
      handler() {
        if (this.autoOutStocks.length) {
          this.autoOutStockIds = this.autoOutStocks.map((stock) => {
            return stock.id;
          });
        } else {
          this.autoOutStockIds = [];
        }
      },
    },
    autoOutSetting: {
      deep: true,
      handler() {
        if (this.autoOutSetting.auto_out == 0) {
          this.autoOutSettingEditFlg = false;
        }
      }
    }
  },
};
</script>